<template>
  <div class="showTemplate">
    <a-statistic-countdown :title="deadtitle" :value="deadline"
      style="margin-left: 50px;position: absolute;right: 130px;top: 10px;" @finish="onFinish" v-if="timer_status"/>

      
    <a-switch checked-children="刷新开启" un-checked-children="刷新关闭" :checked="timer_status"  @change="changeTimerStatus" style="margin-left: 50px;position: absolute;right: 30px;top: 30px;"/>

    <div class="salesCard">
      <a-tabs default-active-key="1"  @change="changeTopTab" 
        :tabBarStyle="{ display: 'flex', justifyContent: 'flex-start', position: 'relative' }">

        <a-tab-pane tab="数据统计" key="1">
          
          <a-spin :spinning="toploading" tip="加载中...">
          <a-row :gutter="24">
            <a-col :sm="24" :md="12" :xl="4" :style="{ marginBottom: '10px' }"> 
              <div class="ant-card">
                <div class="ant-card-body" style="padding: 20px 24px 8px;">
                  <div class="acss-79elbk">
                    <div class="acss-14lc1cu">
                      <div class="acss-qdes8r"></div>
                      <div class="acss-1odwksc">
                        <div class="acss-1qoci3j">
                          <span>消耗（元）</span>
                          <span class="acss-18kfphl">
                            <a-icon type="question-circle" />
                          </span>
                        </div>
                        <div class="acss-f1zikh">
                          <span>¥ {{report.stat_cost||'0.00'}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="acss-grxbm" style="height: 46px;">
                      <div class="acss-16mkun2">
                        <ReportChart  v-if="y1.length>0"  :xData="xData" :yData="y1" id="stat_cost"/>
                      </div>
                    </div>
                    <div class="acss-1fpsglh">
                      <div class="acss-eji7bv">
                        <span class="acss-1x0bxe0">本月</span>
                        <span class="acss-72p16p">￥{{report.month_stat_cost}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </a-col>
            <a-col :sm="24" :md="12" :xl="4" :bordered="false">
              <div class="ant-card">
                <div class="ant-card-body" style="padding: 20px 24px 8px;">
                  <div class="acss-79elbk">
                    <div class="acss-14lc1cu">
                      <div class="acss-qdes8r"></div>
                      <div class="acss-1odwksc">
                        <div class="acss-1qoci3j">
                          <span>新建计划数</span>
                          <span class="acss-18kfphl"><a-icon type="question-circle" />
                          </span>
                        </div>
                        <div class="acss-f1zikh">
                          <span>{{ report.order_count || '0' }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="acss-grxbm" style="height: 46px;">
                      <div class="acss-16mkun2">
                        <ReportChart  v-if="y2.length>0"  :xData="xData" :yData="y2"  id="order_count"/>
                        
                      </div>
                    </div>
                    <div class="acss-1fpsglh">
                      <div class="acss-eji7bv">
                        <span class="acss-1x0bxe0">本月</span>
                        <span class="acss-72p16p">{{report.month_count}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </a-col>
            <a-col :sm="24" :md="12" :xl="4" :bordered="false" >
              <div class="ant-card">
                <div class="ant-card-body" style="padding: 20px 24px 8px;">
                  <div class="acss-79elbk">
                    <div class="acss-14lc1cu">
                      <div class="acss-qdes8r"></div>
                      <div class="acss-1odwksc">
                        <div class="acss-1qoci3j">
                          <span>成交订单金额</span>
                          <span class="acss-18kfphl"><a-icon type="question-circle" />
                          </span>
                        </div>
                        <div class="acss-f1zikh">
                          <span>¥ {{ report.pay_order_amount || '0.00' }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="acss-grxbm" style="height: 46px;">
                      <div class="acss-16mkun2">
                        <ReportChart  v-if="y3.length>0"  :xData="xData" :yData="y3"  id="pay_order_amount"/>
                        
                      </div>
                    </div>
                    <div class="acss-1fpsglh">
                      <div class="acss-eji7bv">
                        <span class="acss-1x0bxe0">本月</span>
                        <span class="acss-72p16p">￥{{report.month_pay_order_amount}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </a-col>
            <a-col :sm="24" :md="12" :xl="4" :bordered="false" >
              <div class="ant-card">
                <div class="ant-card-body" style="padding: 20px 24px 8px;">
                  <div class="acss-79elbk">
                    <div class="acss-14lc1cu">
                      <div class="acss-qdes8r"></div>
                      <div class="acss-1odwksc">
                        <div class="acss-1qoci3j">
                          <span>支付ROI</span>
                          <span class="acss-18kfphl"><a-icon type="question-circle" />
                          </span>
                        </div>
                        <div class="acss-f1zikh">
                          <span>{{ report.prepay_and_pay_order_roi || '0' }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="acss-grxbm" style="height: 46px;">
                      <div class="acss-16mkun2">
                        
                        <ReportChart v-if="y4.length>0" :xData="xData" :yData="y4" id="prepay_and_pay_order_roi"/>
                      </div>
                    </div>
                    <div class="acss-1fpsglh">
                      <div class="acss-eji7bv">
                        <span class="acss-1x0bxe0">本月</span>
                        <span class="acss-72p16p">{{report.month_prepay_and_pay_order_roi}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </a-col>
            <a-col :sm="24" :md="12" :xl="4" :bordered="false" >
              <div class="ant-card">
                <div class="ant-card-body" style="padding: 20px 24px 8px;">
                  <div class="acss-79elbk">
                    <div class="acss-14lc1cu">
                      <div class="acss-qdes8r"></div>
                      <div class="acss-1odwksc">
                        <div class="acss-1qoci3j">
                          <span>成交订单数</span>
                          <span class="acss-18kfphl"><a-icon type="question-circle" />
                          </span>
                        </div>
                        <div class="acss-f1zikh">
                          <span>{{ report.pay_order_count || '0' }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="acss-grxbm" style="height: 46px;">
                      <div class="acss-16mkun2"> 
                        <ReportChart  v-if="y5.length>0" :xData="xData" :yData="y5" id="pay_order_count"/>
                      </div>
                    </div>
                    <div class="acss-1fpsglh">
                      <div class="acss-eji7bv">
                        <span class="acss-1x0bxe0">本月</span>
                        <span class="acss-72p16p">{{report.month_pay_order_count}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </a-col>

            <a-col :sm="24" :md="12" :xl="4"  :bordered="false" >
              <div class="ant-card">
                <div class="ant-card-body" style="padding: 20px 24px 8px;">
                  <div class="acss-79elbk">
                    <div class="acss-14lc1cu">
                      <div class="acss-qdes8r"></div>
                      <div class="acss-1odwksc">
                        <div class="acss-1qoci3j">
                          <span>千次展示费用</span>
                          <span class="acss-18kfphl"><a-icon type="question-circle" />
                          </span>
                        </div>
                        <div class="acss-f1zikh">
                          <span>¥ {{ report.cpm_platform || '0.00' }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="acss-grxbm" style="height: 46px;">
                      <div class="acss-16mkun2">
                        
                        <ReportChart  v-if="y6.length>0"  :xData="xData" :yData="y6" id="cpm_platform"/>
                      </div>
                    </div>
                    <div class="acss-1fpsglh">
                      <div class="acss-eji7bv">
                        <span class="acss-1x0bxe0">本月</span>
                        <span class="acss-72p16p">￥{{report.month_cpm_platform}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>  
            </a-col>

          </a-row>
        </a-spin> 





        </a-tab-pane>
        <a-tab-pane tab="数据分析" key="2"> 
            <div class="grid grid-cols-2 gap-6 mb-6">
              <div class="bg-white p-4 rounded-lg shadow-sm">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="text-lg font-medium">本月转化趋势</h3>
                  <div class="flex items-center space-x-4">
                    <section class="yAxis1" />
                    <a-select v-model="lineChartData.yAxis1" style="width: 150px" placeholder="请选择" @change="changeAxis1">
                      <a-select-option v-for="item in yAxis1options" :key="item.value"  :value="item.value"
                        :disabled="item.disabled" >
                        {{ item.label }}
                      </a-select-option>
                    </a-select>  
                    <section class="yAxis2" />
                    <a-select v-model="lineChartData.yAxis2" style="width: 150px" placeholder="请选择" @change="changeAxis2">
                      <a-select-option v-for="item in yAxis2options" :key="item.value"  :value="item.value"
                        :disabled="item.disabled" >
                        {{ item.label }}
                      </a-select-option>
                    </a-select> 
                  </div>
                </div> 
                <a-spin :spinning="toploading" tip="加载中...">
                  <div ref="chart1" class="w-full h-80"></div> 
                </a-spin>
              </div>
              <div class="bg-white p-4 rounded-lg shadow-sm">
                <div class="flex items-center justify-between mb-4">
                  <div class="flex items-center space-x-4">
                      <a-button :type="circleIndex=='VIDEO'?'primary':''" @click="changeCircle('VIDEO')">视频</a-button>
                      <a-button :type="circleIndex=='PRODUCT'?'primary':''" @click="changeCircle('PRODUCT')">商品</a-button>
                      <a-button :type="circleIndex=='AWEME'?'primary':''" @click="changeCircle('AWEME')">被投放号</a-button>
                      <a-button :type="circleIndex=='BID'?'primary':''" @click="changeCircle('BID')">出价</a-button>
                      <a-button :type="circleIndex=='TARGET'?'primary':''" @click="changeCircle('TARGET')">优化目标</a-button>
                      <a-button :type="circleIndex=='TIME'?'primary':''" @click="changeCircle('TIME')">时长</a-button>
                  </div>
                  <a-select v-model="distributionMetric" style="width: 120px">
                    <a-select-option value="stat_cost">消耗</a-select-option>
                    <a-select-option value="pay_order_amount">成交订单金额</a-select-option>
                    <a-select-option value="pay_order_count">成交订单数</a-select-option>
                  </a-select>
                </div>
                <a-spin :spinning="toploading" tip="加载中...">
                  <div ref="chart2" class="w-full h-80"></div>
                </a-spin>
              </div>
            </div>
            <!-- <line-chart :chart-data="lineChartData" /> -->
          <a-table ref="inOrderTable" :columns="adcolumns" :data-source="advertisertableData"  :pagination="false" :rowKey="(record,index) => index"> 
              </a-table>
        </a-tab-pane>
        <div class="extra-wrapper" slot="tabBarExtraContent">
          <div class="extra-item">
            <a @click="setTimeDay(0)" :class="timeday == '0' ? 'selected':'' ">今日</a>
            <a @click="setTimeDay(-1)" :class="timeday == '-1' ? 'selected':'' ">昨日</a>
            <a @click="setTimeDay(-3)"  :class="timeday == '-3' ? 'selected':'' ">近3天</a>
            <a @click="setTimeDay(-7)"  :class="timeday == '-7' ? 'selected':'' ">近7天</a>
            <a @click="setTimeDay(1)"  :class="timeday == '1' ? 'selected':'' ">本月</a>
            <a @click="setTimeDay(2)"  :class="timeday == '2' ? 'selected':'' ">上月</a>
          </div>

          <a-range-picker  
            :ranges="{
                  '今日': [moment(), moment()],
                  '昨日': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  '本周': [moment().startOf('week'), moment()],
                  '上周': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                  '本月': [moment().startOf('month'), moment()],
                  '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }" 
            :value="range_date" @change="onTimeChange" class="filterItem" showToday
            :placeholder="['开始时间', '结束时间']" /> 

            <!-- <a-button type="info" icon="filter"  style="margin-left: 10px;" @click="selectVisible = true"> 自定义字段</a-button> -->

        </div>


      </a-tabs>
    </div>

    <div class="tableWapper">
      <a-tabs default-active-key="1" @change="changeTab" :tabBarStyle="{ display: 'flex', justifyContent: 'flex-start' }">
        <a-tab-pane key="1" tab="全部计划"></a-tab-pane>
        <a-tab-pane key="-1" :tab="wait_create>0?'待创建('+wait_create+')':'待创建'"></a-tab-pane>
        <a-tab-pane key="2" tab="今日计划" force-render></a-tab-pane>
        <a-tab-pane key="3" tab="昨日计划" force-render></a-tab-pane>
        <a-tab-pane key="8" tab="近3日计划" force-render></a-tab-pane>
        <a-tab-pane key="5" tab="近7日计划" force-render></a-tab-pane>
        <a-tab-pane key="6" tab="本月计划" force-render></a-tab-pane>
        <a-tab-pane key="30" tab="近30日计划" force-render></a-tab-pane>
        <a-tab-pane key="7" tab="上月计划" force-render></a-tab-pane>
        <a-tab-pane key="-99" tab="非投放中" force-render></a-tab-pane>
        <a-tab-pane key="4" :tab="tfz_tab" force-render></a-tab-pane>
      </a-tabs>
      <div v-show="timeType!='WAIT'">
        <div class="filterCondition">
          <a-space>
            <a-button type="primary" @click="createBtn">
              + 新建计划
            </a-button>
            <a-button type="danger" @click="batchClose" v-if="selectedRowKeys.length > 0">
              批量关停 ( {{ selectedRowKeys.length }} )</a-button> 
            <a-button type="disabled" @click="selectTips" v-else> 批量关停 </a-button>

            <a-button type="primary" style="background: green;" @click="batchZt" v-if="selectedRowKeys.length > 0">
              批量追投( {{ selectedRowKeys.length }} )</a-button> 
            <a-button type="disabled"  @click="selectTips" v-else> 批量追投 </a-button>
            
            <a-button type="primary"  @click="batchCopy" v-if="selectedRowKeys.length > 0">
              批量复制( {{ selectedRowKeys.length }} )</a-button> 
            <a-button type="disabled"  @click="selectTips" v-else> 批量复制 </a-button>


            <a-button type="disabled" icon="edit" @click="selectTips"   v-if="selectedRowKeys.length == 0"  >批量备注</a-button>
            <a-popover title="批量备注" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}" placement="bottom" trigger="click" v-else>
              <template slot="content">
                <p><a-textarea placeholder="设置备注" v-model="remark"  style="width: 100%;"/></p>
                <p><a-button type="primary" icon="edit" :disabled="data.length==0" style="width: 100%;" @click="remarkBatch()">批量设置备注</a-button></p>
              </template>
              <a-button type="primary" icon="edit"  @click="remark=''">批量备注</a-button>
            </a-popover>





            <a-button type="primary" icon="download" :disabled="data.length==0"  v-if="timeType!='ALL'"  @click="downExcel()">下载报表</a-button>
            <a-popover title="选择月份"  placement="bottom" trigger="click" v-else>
              <template slot="content">
                <p><a-month-picker placeholder="选择月份" @change="onChangeMonth"/></p>
                <p><a-button type="primary" icon="download" :disabled="data.length==0" style="width: 100%;" @click="downExcel()">下载整月报表</a-button></p>
              </template>
              <a-button type="primary" icon="download" >下载报表</a-button>
            </a-popover>

            
            <!-- <a-popover title="选择时间"  placement="bottom" trigger="click">
              <template slot="content">
                <p><a-date-picker placeholder="选择时间" @change="onChangeDay"/></p>
                <p><a-button type="primary" icon="download" :disabled="data.length==0" style="width: 100%;" @click="downDayExcel()">下载整日报表</a-button></p>
              </template>
              <a-button type="primary" icon="download"  v-if="timeType!='ALL'" >整日报表</a-button>
            </a-popover> -->
            <a-select v-model="status" style="width: 130px" @change="handleChange" placeholder="全部计划状态">
              <a-select-option v-for="(item, index) in statusData" :key="index" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select v-model="delivery_setting_external_action" style="width: 130px" @change="handletargetChange" placeholder="全部计划状态">
              <a-select-option v-for="(item, index) in targetData" :key="index" :value="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          
            <!-- <span><a-icon type="clock-circle" />  {{ lasttime }} </span> -->
            <a-input  style="width: 150px;margin-left: 0px;" placeholder="备注"  @change="onSearchRemark" v-model="search_remark" />


            <a-checkbox @change="showTodayData" :checked="showToday">
              当日数据
            </a-checkbox>

          </a-space>
          <a-space>

            <a-input-search :allowClear="true" placeholder="计划ID/视频标题/视频ID/抖音昵称/抖音ID" v-model="order_id" enter-button @search="onSearchKey"  />

            <a-button type="info" icon="filter"  style="margin-left: 20px;"  @click="columnsVisible=true"> </a-button>
          </a-space>
        </div>
        <a-spin :spinning="spinning" tip="加载中...">
          <div class="scroll-tabox" style="position: relative;padding-bottom: 50px;">
            <a-table ref="inOrderTable" :columns="columns" :data-source="data" :pagination="pagination" :sortDirections="['descend', 'ascend','']"
              @change="handleTableChange" :rowKey="(record) => record.ad_id" :rowSelection="{
                selectedRowKeys,
                onChange: onSelectChange,
              }" :scroll="{ x: 2000 }"  >
              <div slot="ad" class="aweme-right" slot-scope="text">
                <div class="aweme-title" style="margin-bottom: 0px;">
                  <span @click="reflesh(text,true)">
                  <a-popover placement="topLeft">
                    <template slot="content">
                      <p>触发时间：{{ text.mcreatetime }}</p>
                      <p>原计划ID：{{ text.mid }} <a-icon type="copy" @click="text_copy(text.mid)" /></p>
                      <div class="form-control" v-html="text.mcontent"> </div>
                    </template>
                    <span slot="title">该计划来源于监控复投</span>
                    <a-badge count="高产复投" :number-style="{ backgroundColor: '#52c41a' }" v-if="text.mid&&text.mtype=='gcft' " />
                    <a-badge count="超时复投" :number-style="{ backgroundColor: 'green' }" v-if="text.mid&&text.mtype=='csft' " />

                  </a-popover>
                  <a-badge count="定时投放" :number-style="{ backgroundColor: '#fa8c16' }" v-if="text.dotype=='SET' " />
                  <a-badge count="长期投放" :number-style="{ backgroundColor: '#f5222d' }" v-if="text.dotype=='LONG' " />
                  <a-badge count="分批投放" :number-style="{ backgroundColor: '#ff4d4f' }" v-if="text.dotype=='BATCH' " />
                  <a-badge count="定时分批" :number-style="{ backgroundColor: '#eb2f96' }" v-if="text.dotype=='SETBATCH' " />
                  ID:{{ text.order_id }}
                </span>
                  
                <a-icon type="copy" @click="text_copy(text.order_id)"/> 

                </div>
                
                <div> 
                  <a-popover  title="设置备注"  placement="bottomLeft" trigger="click"  :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <template slot="content">
                          <p>
                            <a-textarea placeholder="设置备注" v-model="remark"  style="width: 100%;"/> 
                          </p> 
                          <p><a-button type="primary" icon="edit"  style="width: 100%;" @click="setAdRemark(text)">设置备注</a-button></p>
                        </template>
                        <span v-if="text.remark==''">备注 <a-icon type="edit" style="cursor: pointer;"/></span>
                        <span v-else :title="text.remark" class="remark" @click="remark=text.remark">{{text.remark}} <a-icon type="edit" style="cursor: pointer;"/></span>
                  </a-popover> 
                </div>
                <div>创建时间：{{ text.order_create_time }}</div>
                <div>优化目标：{{text.external_action_text}} </div>
                  <div v-if="text.monitor_info">
                    <div v-if="text.status_text == '投放中'">
                      <div v-if="text.is_white">
                        <span style="color: #333;" > <a-icon type="wifi" /> 未监控</span> 
                        <a-tooltip placement="topLeft" title="取消加白计划，计划将会重新被监控"> 
                          <span style="color: #597ef7;cursor: pointer;"  @click="addwhite(text,'del')"> 取消加白</span>
                        </a-tooltip> 
                      </div>
                      <div v-else>
                        <span style="color: green;" ><a-icon type="wifi" /> 监控中</span>  
                        <a-tooltip placement="topLeft" title="加入计划白名单后，该计划将不会被监控"> 
                          <span style="color: #597ef7;cursor: pointer;"  @click="addwhite(text,'add')"> 加白</span>
                        </a-tooltip> 
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div><span><a-icon type="wifi" /> 未配置</span>  <span style="color: #597ef7;cursor: pointer;"  @click="setmonitor">去配置</span> </div>
                  </div>
                </div>

              <div class="aweme" slot="aweme" slot-scope="text">
                <div class="aweme-left">
                  <img slot="aweme_item_cover" @click="govideo(text)" class="videoimg" :src="text.aweme_item_cover"
                    v-if="text.aweme_item_cover" />
                </div>
                <div class="aweme-right">
                  <div class="aweme-title" @click="getVidioItem(text)" style="margin-bottom: 0px;">{{ text.video_info_aweme_item_title }}</div>
                  <div class="aweme-name" style="font-size: 12px;cursor: pointer;margin-top: 5px;"><span @click="getAwemeItem(text)" >{{ text.aweme_info_aweme_name }}</span>：{{ text.aweme_info_aweme_id }} <a-icon type="copy" @click="text_copy(text.aweme_info_aweme_id)" /></div>
                  <div class="aweme-id" v-if="text.product_info_img" @click="getDetail(text,'product')" >
                    <div class="aweme-id-left">
                      <img :src="text.product_info_img">
                    </div>
                    <div class="aweme-id-right">
                      <h6>{{ text.product_info_name }}</h6>
                      <p> ID:{{ text.product_info_id }} <a-icon type="double-right" /></p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="delivery_setting" slot="delivery_setting" slot-scope="text">  
                <div v-if="text.delivery_setting_amount" style="color: green;font-weight: bold">共投:{{ parseInt(text.delivery_setting_amount)+ parseInt(text.add_amount_info_add_amount||0) }}元  <a-icon type="redo" @click="reflesh(text)" style="cursor: pointer;" /> </div>
                <!-- <div v-if="text.delivery_setting_cpa_bid" style="color: green;font-weight: bold">出价:{{ text.delivery_setting_cpa_bid }}元</div> -->
                <!-- <div v-if="text.delivery_setting_roi_goal" style="color: green;font-weight: bold">ROI目标:{{ text.delivery_setting_roi_goal }}</div> -->
                <div v-if="text.delivery_setting_payment_amount&&text.coupon_info_coupon_amount>0">实付:{{ text.delivery_setting_payment_amount }}元/券:{{ text.coupon_info_coupon_amount }}元</div>
                <div v-if="text.add_amount_info_add_amount">投放:{{ text.delivery_setting_amount }}元/续费:{{ text.add_amount_info_add_amount }}元</div>
                <div v-if="text.add_amount_info_add_amount_cnt">共续:{{ text.add_amount_info_add_amount_cnt }}次/{{ text.add_amount_info_add_delivery_time }}天</div>

                <div  style="color: rgb(24, 144, 255);" v-if="text.delivery_setting_bid_type=='AUTO_BID'">自动出价</div>
                <div  style="color: green;" v-else-if="text.delivery_setting_bid_type=='MANUAL_BID'">
                  <span v-if="text.delivery_setting_cpa_bid">出价:{{text.delivery_setting_cpa_bid}} 元</span>
                  <span v-if="text.delivery_setting_roi_goal">ROI:{{text.delivery_setting_roi_goal}}</span>
                </div>

                <div> 
                  <a-progress :percent="parseInt(text.stat_cost/(parseInt(text.delivery_setting_amount)+ parseInt(text.add_amount_info_add_amount||0) + parseInt(text.coupon_info_coupon_amount||0))*100)" size="small" status="active" v-if="parseInt(text.stat_cost/(parseInt(text.delivery_setting_amount)+ parseInt(text.add_amount_info_add_amount||0) + parseInt(text.coupon_info_coupon_amount||0))*100)<70" /> 
                  <a-progress strokeColor="#f5222d" :percent="parseInt(text.stat_cost/(parseInt(text.delivery_setting_amount)+ parseInt(text.add_amount_info_add_amount||0) + parseInt(text.coupon_info_coupon_amount||0))*100)" size="small" status="active" v-else-if="parseInt(text.stat_cost/(parseInt(text.delivery_setting_amount)+ parseInt(text.add_amount_info_add_amount||0) + parseInt(text.coupon_info_coupon_amount||0))*100)<100 && parseInt(text.stat_cost/(parseInt(text.delivery_setting_amount)+ parseInt(text.add_amount_info_add_amount||0) + parseInt(text.coupon_info_coupon_amount||0))*100)>=70" /> 
                  <a-progress :percent="100" size="small"  v-else />
                </div>
                
                <div style="color: rgb(24, 144, 255);">
                  <span v-if="text.status_text == '投放中'">{{text.c_hour}}</span><span v-else >已结束</span>
                   / {{text.delivery_setting_delivery_time}}h<span v-if="text.add_amount_info_add_delivery_time">+{{ text.add_amount_info_add_delivery_time }}天</span> </div>
              
              </div>

              

              <template slot="return_rate_info" slot-scope="text" >

                <b  style="color: red"  v-if="( text.product_info_discount_lower_price/(text.product_info_discount_lower_price*text.commission_rate/100*(1-text.return_rate/100-0.1)) ).toFixed(2)>text.prepay_and_pay_order_roi"> {{ ( text.product_info_discount_lower_price/(text.product_info_discount_lower_price*text.commission_rate/100*(1-text.return_rate/100-0.1)) ).toFixed(2) }}</b>
                <b  style="color: green"  v-else> {{ ( text.product_info_discount_lower_price/(text.product_info_discount_lower_price*text.commission_rate/100*(1-text.return_rate/100-0.1)) ).toFixed(2) }}</b>

              </template>

              <template slot="status_text" slot-scope="text">
                <a-tag v-if="text == '投放中'" color="green">
                  {{ text }}
                </a-tag>
                <a-tag v-else color="red">
                  {{ text }}
                </a-tag>
 
              </template>

              <template slot="commission_rate" slot-scope="text" >
                <b>{{ text.commission_rate }}% </b>
                <a-icon type="edit" style="cursor: pointer;"  @click="getDetail(text,'rate')"/>
              </template>

              <div class="green-roi" slot="profit_and_loss" slot-scope="text">

                <b v-if="text > 2" style="color: green;">{{ text }}</b>
                <b v-else style="color: red;">{{ text }}</b>


              </div>

              <div class="green-roi" slot="prepay_and_pay_order_roi" slot-scope="text">

                <b v-if="text.profit_and_loss > 0" style="color: green;">{{ text.prepay_and_pay_order_roi }}</b>
                <b v-else style="color: red;">{{ text.prepay_and_pay_order_roi }}</b>
                <!-- <p>（ 保本:1.0 ）</p> -->
              </div>

              <div slot="action" slot-scope="text, record"> 
                  <div class="rowOperate" > <span slot="action" class="actionItem" @click="reflesh(record,true)">详情</span>  <span slot="action" class="actionItem" @click="getadEchart(record)">趋势</span> </div>  
                  <div class="rowOperate" > <b slot="action" class="actionItem" @click="copyOrder(record)" style="color: green">复制</b> <b  style="color: red" slot="action" class="actionItem" @click="stopOrder(record)">关停</b> </div> 
                  <div class="rowOperate" v-if="record.status=='DELIVERY_OK'"> <b slot="action" class="actionItem" @click="ztOrder(record)"  style="color: green">追投</b> </div> 
              </div>
            </a-table>
          </div>
        </a-spin>
      </div>
      <div v-show="timeType=='WAIT'">
        <a-spin :spinning="spinning" tip="加载中...">
          <div class="scroll-tabox">
            <planlist ref="plan" :new_marketing_goal="marketing_goal" :advertiser_id="advertiser_id" :timeType="timeType" :aweme_item_id="video_info_aweme_item_id"  :aweme_id="aweme_info_aweme_id" @getTasklist="getTasklist"/>
          </div>
        </a-spin>
      </div>

    </div>

    <a-drawer v-if="orderDrawer" class="authAccount" title="订单详情" width="1000px" placement="right" :visible="orderDrawer"
      @close="orderDrawer = false"  :bodyStyle="{overflow: 'auto', height: 'calc(100% - 161px)'}">
      <div class="searchResult">
        <span class="name">{{ order_detail.video_info_aweme_item_title }}</span>
        <div class="tags-container">
          <span class="info-item">抖音号：<img class="avatar" :src="order_detail.aweme_info_aweme_avatar" />{{
            order_detail.aweme_info_aweme_name }}</span>
          <span class="ad-tag tag green" v-if="ad.status == 'DELIVERY_OK'">{{
            ad.status_text
          }}</span>
          <span class="ad-tag tag red" v-else>{{ ad.status_text }}</span>
          <span class="ad-tag tag">随心推计划ID: {{ order_detail.order_id }} <a-icon type="copy" @click="text_copy(ad.order_id)"/> </span>
          <span class="ad-tag tag">千川计划ID: {{ ad.ad_id }}
                <a-icon type="copy" @click="text_copy(ad.ad_id)"/> </span>
        </div>
        <div class="ad-drawer__aweme-info" v-if="order_detail.product_info">
          <div class="product-item">
            <div class="byted-popover-wrapper">
              <div class="good">
                <img :src="order_detail.product_info_img" alt="商品图片" class="icon" />
              </div>
            </div>
            <div class="info">
              <p class="name">
                {{ order_detail.product_info_name }}
              </p>
              <span class="id">商品ID {{ order_detail.product_info_id }}</span><span class="separator"></span><span
                class="price">
                价格<span class="price-num">
                  {{ order_detail.product_info_discount_lower_price }}
                  <span>
                    - {{ order_detail.product_info_discount_higher_price }}
                  </span></span>
                元
              </span>
            </div>
          </div>
        </div>
      </div>

      <a-alert :message="order_detail.audit_record_status_attach_desp" banner type="info" show-icon v-if="order_detail.audit_record_status_attach_desp!='' && (order_detail.status=='FINISHED'||order_detail.status=='DELIVERY_OK'||order_detail.status=='OVER')"/>

      <a-alert :message="order_detail.audit_record_status_attach_desp" banner type="error" show-icon v-if="order_detail.audit_record_status_attach_desp!=''  && order_detail.status!='FINISHED' && order_detail.status!='DELIVERY_OK' &&order_detail.status!='OVER' "/>


      <div v-if="order_detail?.audit_record_detail_desc_list.length>0">
        <div v-for="(item,index) in order_detail?.audit_record_detail_desc_list" :key="index" style="margin-top: 10px;">
          <a-alert
            :description="item"
            type="error"
          />
        </div>
      </div>
      <div style="border-top: 1px solid #eee;margin-top: 10px;">
        <a-tabs :default-active-key="detailTab" @change="changeDetailTopTab" :tabBarStyle="{ display: 'flex', justifyContent: 'flex-start', position: 'relative' }">
          <a-tab-pane tab="数据概览" key="1"> 
            <div class="title" style="margin-top: 0px;">数据概览</div>
            <div class="board-list">
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">消耗(元)</p>
                  <p class="value">{{ ad.stat_cost }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">成交金额</p>
                  <p class="value">{{ ad.pay_order_amount }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">支付ROI</p>
                  <p class="value">{{ ad.prepay_and_pay_order_roi }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">播放次数</p>
                  <p class="value">{{ ad.total_play }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">展示次数</p>
                  <p class="value">{{ ad.show_cnt }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">成交订单数</p>
                  <p class="value">{{ ad.pay_order_count }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">点击率</p>
                  <p class="value">{{ ad.ctr*100 }}%</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">点击次数</p>
                  <p class="value">{{ ad.click_cnt }}</p>
                </div>
              </div>

              <!-- <div class="overview-board">
                <div class="inner">
                  <p class="metric">转化数</p>
                  <p class="value">{{ ad.convert_cnt }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">转化成本</p>
                  <p class="value">{{ ad.convert_cost }}</p>
                </div>
              </div> -->

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">广告预售订单数</p>
                  <p class="value">{{ ad.prepay_order_count }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">广告预售订单金额</p>
                  <p class="value">{{ ad.prepay_order_amount }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">新增粉丝数</p>
                  <p class="value">{{ ad.dy_follow }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">分享次数 </p>
                  <p class="value">{{ ad.dy_share }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">评论次数 </p>
                  <p class="value">{{ ad.dy_comment }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">点赞次数</p>
                  <p class="value">{{ ad.dy_like }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">主页访问量 </p>
                  <p class="value">{{ ad.dy_home_visited }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">转化数  </p>
                  <p class="value">{{ ad.ecp_convert_cnt }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">转化成本   </p>
                  <p class="value">{{ ad.ecp_cpa_platform }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">点赞率   </p>
                  <p class="value">{{ ad.like_rate }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">5s完播率   </p>
                  <p class="value">{{ ad.play_duration_5s_rate }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">查看购物车次数   </p>
                  <p class="value">{{ ad.luban_live_slidecart_click_cnt }}</p>
                </div>
              </div>
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">商品点击次数   </p>
                  <p class="value">{{ ad.luban_live_click_product_cnt }}</p>
                </div>
              </div>


            </div>
          </a-tab-pane>
          <a-tab-pane tab="计划详情" key="2"> 
            <div class="title" style="margin-top: 0px;">投放设置</div>
            <div class="delivery-tab">
              <div class="setting-item">
                <label>投放金额</label>
                <div class="display-value">
                  <div>{{ order_detail.delivery_setting_amount }} 元</div>
                </div>
              </div>

              <div class="setting-item">
                <label>优化目标</label>
                <div class="display-value">
                  <div>
                    {{ ad.external_action_text }}
                  </div>
                </div>
              </div>

              <div class="setting-item">
                <label>曝光时长</label>
                <div class="display-value">
                  <div>{{ order_detail.delivery_setting_delivery_time }} 小时</div>
                </div>
              </div>

              <div class="setting-item">
                <label>出价模式</label>
                <div class="display-value">
                  <div v-if="order_detail.delivery_setting_bid_mode == 'PRICING_ACTION'">
                    按优化目标出价
                  </div>
                  <div v-else>按播放量出价</div>
                </div>
              </div>

              <div class="setting-item">
                <label>出价类型</label>
                <div class="display-value">
                  <div v-if="order_detail.delivery_setting_bid_type == 'AUTO_BID'">
                    自动出价
                  </div>
                  <div v-else>手动出价</div>
                </div>
              </div>

              <div class="setting-item" v-if="order_detail.delivery_setting_cpa_bid">
                <label>手动出价</label>
                <div class="display-value">
                  <div>
                    {{ order_detail.delivery_setting_cpa_bid }}
                  </div>
                </div>
              </div>
              <div class="setting-item" v-if="order_detail.delivery_setting_roi_goal">
                <label>支付ROI目标</label>
                <div class="display-value">
                  <div>
                    {{ order_detail.delivery_setting_roi_goal }}
                  </div>
                </div>
              </div>
              <div class="setting-item" v-if="order_detail.delivery_setting_liveroom_heat_mode">
                <label>直播间加热方式</label>
                <div class="display-value">
                  <div v-if="
                    order_detail.delivery_setting_liveroom_heat_mode == 'BY_ROOM'
                  ">
                    直接加热直播间
                  </div>
                  <div v-else>选择视频加热直播间</div>
                </div>
              </div>
            </div> 
            <div style="clear: both;"></div>
            <div class="title">定向人群</div>
            <div class="delivery-tab">
              
              <div class="setting-item">
                <label>潜在用户</label>
                <div class="display-value"> 
                  <div v-if="order_detail.audience_audience_mode == 'ATUO'">系统智能推荐</div>
                  <div v-else-if="order_detail.audience_audience_mode == 'CUSTOM'">自定义</div>
                  <div v-else-if="order_detail.audience_audience_mode == 'FANS'">达人相似粉丝</div>
                  <div v-else-if="order_detail.audience_audience_mode == 'LIVEFANS'">达人相似观众</div>
                </div>
              </div>
            
            </div>
            <div class="delivery-tab" style="height: 600px;"  v-if="order_detail.audience_audience_mode != 'ATUO'">
              
              <div class="setting-item" >
                <label>性别</label>
                <div class="display-value"> 
                  <div v-if="order_detail.audience_gender == 'GENDER_FEMALE'">女性</div>
                  <div v-else-if="order_detail.audience_gender == 'GENDER_MALE'">男性</div>
                  <div v-else="">不限</div> 
                </div>
              </div>
              
              <div class="setting-item" >
                <label>年龄</label>
                <div class="display-value" v-if="order_detail.audience_age.length>0"> 
                  <span  v-for="(item, index) in order_detail.audience_age" :key="index" >
                    <b v-if="item=='AGE_BETWEEN_18_23'">18-23岁、</b>
                    <b v-if="item=='AGE_BETWEEN_24_30'">24-30岁、</b>
                    <b v-if="item=='AGE_BETWEEN_31_40'">31-40岁、</b>
                    <b v-if="item=='AGE_BETWEEN_41_50'">41-50岁、</b>
                  </span> 
                </div>
                <div class="display-value" v-else=""> 
                  <div>不限</div> 
                </div>
              </div>

              <div class="setting-item" >
                <label>限运地区</label>
                <div class="display-value" > 
                  <div  v-if="order_detail.audience_exclude_limited_region == '1' ">排除</div> 
                  <div  v-if="order_detail.audience_exclude_limited_region == '0'">不排除</div> 
                </div>
              </div>

              <div class="setting-item" v-if="order_detail.audience_citystr">
                <label>地域定向</label>
                <div class="display-value" > 
                  <span  v-for="(item, index) in order_detail.audience_citystr" :key="index" >
                    {{item}}
                  </span> 
                </div>
              </div>

              <div class="setting-item" v-if="order_detail.audience_interest_categories">
                <label>兴趣定向</label>
                <div class="display-value" > 
                  <span  v-for="(item, index) in order_detail.audience_interest_categories" :key="index" >
                    <b v-if="item=='1000'">金融、</b> 
                    <b v-if="item=='1001'">汽车、</b> 
                    <b v-if="item=='1002'">旅游、</b> 
                    <b v-if="item=='1003'">房产、</b> 
                    <b v-if="item=='1004'">科技、</b> 
                    <b v-if="item=='1005'">娱乐、</b> 
                    <b v-if="item=='1006'">家装、</b> 
                    <b v-if="item=='1007'">生活、</b> 
                    <b v-if="item=='1008'">游戏、</b> 
                    <b v-if="item=='1009'">教育、</b> 
                    <b v-if="item=='1010'">体育、</b> 
                    <b v-if="item=='1011'">美食、</b> 
                    <b v-if="item=='1012'">母婴、</b> 
                    <b v-if="item=='1013'">法律、</b> 
                    <b v-if="item=='1014'">服饰、</b> 
                    <b v-if="item=='1015'">美妆、</b> 
                    <b v-if="item=='1016'">商务服务、</b> 
                  </span> 
                </div>
              </div>

              <div class="setting-item" v-if="order_detail.audience_author_list">
                <label>达人：</label>
                <div class="display-value" > 
                  <div  v-for="(item, index) in order_detail.audience_author_list" :key="index" style="line-height: 40px">
                    <img :src="item.avatar" style="width: 30px;height: 30px;border-radius: 50%;border: 1px solid #eee;"/> {{item.author_name}} ({{ item.total_fans_num_str }})
                  </div> 
                </div>
              </div>

            </div> 
          </a-tab-pane>
          <a-tab-pane tab="操作日志" key="3">
            <a-table
              style="width: 100%;"
              :columns="user_log_columns"
              :data-source="user_log_data"
              :rowKey="(record, index) => { return index }"
            >  
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="监控日志" key="4"> 
            <a-table
              style="width: 100%;"
              :columns="monitor_log_columns"
              :data-source="monitor_log_data"
              :rowKey="(record, index) => { return index }"
            >  
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="footer">
        <a-button type="primary" @click="copyOrder(ad)">再来一单</a-button>
        <a-button type="primary" @click="ztOrder(ad)" style="background: green;"  v-if="ad.status=='DELIVERY_OK'">追投计划</a-button>
        <a-button @click="stopOrder(ad)">关停订单 </a-button>
      </div>
    </a-drawer>

    
    <a-drawer v-if="productDrawer" class="authAccount" title="商品详情" width="1160px" placement="right" :visible="productDrawer"
      @close="productDrawer = false"  :bodyStyle="{overflow: 'auto', height: 'calc(100% - 161px)'}">
      
      
      <a-spin :spinning="productloading" tip="加载中...">
        <div class="searchResult" style="border-bottom: 1px solid #ebebeb;">
          <!-- <span class="name">{{ order_detail.video_info.aweme_item_title }}</span>
          <div class="tags-container">
            <span class="info-item">抖音号：<img class="avatar" :src="order_detail.aweme_info.aweme_avatar" />{{
              order_detail.aweme_info.aweme_name }}</span>
            <span class="ad-tag tag green" v-if="ad.status == 'DELIVERY_OK'">{{
              ad.status_text
            }}</span>
            <span class="ad-tag tag red" v-else>{{ ad.status_text }}</span>
            <span class="ad-tag tag">随心推计划ID: {{ order_detail.order_id }}</span>
            <span class="ad-tag tag">千川计划ID: {{ ad.ad_id }}</span>
          </div> -->
          <div class="ad-drawer__aweme-info">
            <div class="product-item">
              <div class="byted-popover-wrapper">
                <div class="good">
                  <img :src="order_detail.product_info.img" alt="商品图片" class="icon" />
                </div>
              </div>
              <div class="info">
                <p class="name">
                  <span class="ad-tag tag green" v-if="productDetail.is_assured">安心购</span>
                  <span class="ad-tag tag green" v-if="productDetail.has_sxt">随心推资质</span>
                  <span class="ad-tag tag red" v-if="!productDetail.has_sxt">无随心推资质</span>
                  <span class="ad-tag tag green" v-if="productDetail.in_stock">有库存</span>
                  <span class="ad-tag tag red" v-if="!productDetail.in_stock">无库存</span>
                  {{ order_detail.product_info.name }}
                </p>
                <span class="id">
                  
                  <a-icon type="shopping" /> 商品ID {{ order_detail.product_info.id }}</span><span class="separator"></span>
                  
                  
                <span class="price"> 
                  <a-icon type="home" /> {{productDetail.shop_name}}
                </span>
                <span class="separator"></span>
                
                <span class="price"> 价格<span class="price-num">
                    {{ order_detail.product_info.discount_lower_price }}
                    <span>
                      - {{ order_detail.product_info.discount_higher_price }}
                    </span></span>
                  元
                </span>

                <span class="separator"></span>
                <span class="price" v-if="productDetail.shop_total_score"> 
                  商家体验分： {{productDetail.shop_total_score.shop_score.score}}
                </span>

              </div>
            </div>
          </div>
          <div class="tags-container"> 
            <a :href="productDetail.detail_url" target="_blank">
            <span class="ad-tag tag">商品链接: {{ productDetail.detail_url }}
            </span></a>
          </div>
          <div style="padding-bottom: 16px;">  
            <span class="ad-tag tag">普通佣金率: {{ productDetail.cos_ratio }} %
            </span> 
            <span class="ad-tag tag green">达人佣金率: {{ productDetail.kol_cos_ratio }} %
            </span> 
          </div>
        </div>
        <div class="title">近<b style="color:red">30</b>天推广数据</div>
        <div class="board-list">
          <div :class="productnav==1?'overview-board active':'overview-board'" @click="checkNav(1)">
            <div class="inner">
              <p class="metric">销量</p>
              <p class="value">{{ productDetail.order_num }}</p>
            </div>
          </div>

          <div :class="productnav==2?'overview-board active':'overview-board'"  @click="checkNav(2)">
            <div class="inner">
              <p class="metric">浏览量</p>
              <p class="value">{{ productDetail.view_num }}</p>
            </div>
          </div>

          <div :class="productnav==3?'overview-board active':'overview-board'"  @click="checkNav(3)">
            <div class="inner">
              <p class="metric">推广达人数</p>
              <p class="value">{{ productDetail.kol_num }}</p>
            </div>
          </div>

          <div :class="productnav==4?'overview-board active':'overview-board'"  @click="checkNav(4)">
            <div class="inner">
              <p class="metric">播放转化率</p>
              <p class="value">{{ productDetail.order_num>0?(productDetail.view_num/productDetail.order_num).toFixed(2):0 }}</p>
            </div>
            <span>越低越好</span>
          </div>
          <div :class="productnav==5?'overview-board active':'overview-board'"  @click="checkNav(5)">
            <div class="inner">
              <p class="metric">人均转化率</p>
              <p class="value">{{ productDetail.kol_num>0?(productDetail.order_num/productDetail.kol_num).toFixed(2):0 }}</p>
            </div>
            <span>越高越好</span>
          </div>
          <div :class="productnav==6?'overview-board active':'overview-board'"  @click="checkNav(6)">
            <div class="inner">
              <p class="metric">人均播放率</p>
              <p class="value">{{ productDetail.kol_num>0?(productDetail.view_num/productDetail.kol_num).toFixed(2):0 }}</p>
            </div>
            <span>越高越好</span>
          </div>
        </div>


      </a-spin>

        <div>
              <line-chart :chart-data="lineProductChartData" />
        </div>
      
        <div class="title">相关视频推荐</div>

        

      <div class="footer"> 
        <a-button @click="productDrawer=false">关闭 </a-button>
      </div>
    </a-drawer>


    <a-modal v-if="copyVisible" v-model="copyVisible" title="批量复制计划" width="1000px" okText="立即创建" @ok="copyOrderSubmit">
      <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
      
        <a-form-item label="计划信息">
          <div style="display: flex">
            <div style="display: inline-flex">
              <img @click="govideo(ad)" :src="ad.aweme_item_cover" alt="商品图片" class="copy-icon" />
            </div>
            <div style="padding-left: 15px;line-height: 22px;">
              <b style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 600px;display: block;">{{ ad.aweme_item_title }}</b>
              <div>计划ID：{{ ad.order_id }}</div>
              <div>消耗：{{ ad.stat_cost }} 成交金额：{{ad.pay_order_amount}} ROI：{{ ad.prepay_and_pay_order_roi }}</div>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="优化目标">
          <div class="external-action-wrapper">
            <div class="layer">
              <div class="row">
                <div @click="set_external_action('AD_CONVERT_TYPE_SHOPPING')"
                  :class="external_action == 'AD_CONVERT_TYPE_SHOPPING' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
                  <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onxiadan.png~tplv-55ejei7tpt-image.image" class="icon"
                    width="16" height="16" />
                  <div class="label">
                    商品购买
                  </div>
                </div>

                <div @click="set_external_action('AD_CONVERT_TYPE_LIVE_ROI')"
                  :class="external_action == 'AD_CONVERT_TYPE_LIVE_ROI' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
                  <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onxiadan.png~tplv-55ejei7tpt-image.image" class="icon"
                    width="16" height="16" />
                  <div class="label">
                    支付ROI
                  </div>
                  <span class="newico"> New </span>
                </div>

                <div @click="set_external_action('AD_CONVERT_TYPE_QC_FOLLOW_ACTION')"
                  :class="external_action == 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
                  <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onfensi.png~tplv-55ejei7tpt-image.image" class="icon"
                    width="16" height="16" />
                  <div class="label">
                    粉丝提升
                  </div>
                </div>
                <div @click="set_external_action('AD_CONVERT_TYPE_QC_MUST_BUY')"
                  :class="external_action == 'AD_CONVERT_TYPE_QC_MUST_BUY' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
                  <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onpinglun.png~tplv-55ejei7tpt-image.image" class="icon"
                    width="16" height="16" />
                  <div class="label">
                    点赞评论
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="出价模式" v-if="false">
          <div class="external-action-wrapper">
            <div class="layer">
              <div class="row">
                <div @click="set_bid_mode('PRICING_ACTION')"
                  :class="bid_mode == 'PRICING_ACTION' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
                  <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onxiadan.png~tplv-55ejei7tpt-image.image" class="icon"
                    width="16" height="16" />
                  <div class="label">
                    按优化目标出价 
                  </div>
                </div>
                <div @click="set_bid_mode('PRICING_PLAY')"
                  :class="bid_mode == 'PRICING_PLAY' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
                  <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onfensi.png~tplv-55ejei7tpt-image.image" class="icon"
                    width="16" height="16" />
                  <div class="label">
                    按播放量出价
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="投放时长">
          <div class="external-action-wrapper" style="text-align: left;">
            <a-radio-group :value="delivery_time" @change="handleDeliveryTimeChange">
              <a-radio-button value="2">
                2小时
              </a-radio-button>
              <a-radio-button value="6">
                6小时
              </a-radio-button>
              <a-radio-button value="12">
                12小时
              </a-radio-button>
              <a-radio-button value="24">
                24小时
              </a-radio-button>
              <a-radio-button value="72">
                3天
              </a-radio-button>
              <a-radio-button value="120">
                5天
              </a-radio-button>
            </a-radio-group>
          </div>
        </a-form-item>

        <a-form-item label="出价类型">
          <div class="delivery-date-wrapper"  v-show="external_action != 'AD_CONVERT_TYPE_LIVE_ROI'" >
            <div class="container interval normal"> 
              <a-radio-group :value="bid_type" @change="handleBipTypeChange">
                <a-radio-button value="AUTO_BID" :disabled="external_action == 'AD_CONVERT_TYPE_LIVE_ROI'">
                  自动出价
                </a-radio-button>
                <a-radio-button value="MANUAL_BID">
                  手动出价
                </a-radio-button>
              </a-radio-group>
              <a-input-number :min="0.1" :max="10000" placeholder="手动出价金额" v-model="cpa_bid" class="cpa_bid"
              v-if="bid_type == 'MANUAL_BID'&& external_action != 'AD_CONVERT_TYPE_LIVE_ROI'"/> 
            </div>
          </div>
          <div v-if="external_action == 'AD_CONVERT_TYPE_LIVE_ROI'" class="form-item-container horizontal" >
            <div style="display: flex;">
              <div class="title-box level-4 normal">支付roi目标</div>
              <div class="delivery-date-wrapper">
                <div class="container interval normal"> 
                  <a-input-number :min="0.01" :max="100" placeholder="支付roi目标" v-model="roi_goal" class="cpa_bid" /> 
                </div>
              </div>
            </div>
          </div> 
        </a-form-item>

        <a-form-item label="投放金额">
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">
              <a-radio-group :value="amount" @change="handleAmountChange">
                <a-radio-button value="100">
                  100元
                </a-radio-button>
                <a-radio-button value="200">
                  200元
                </a-radio-button>
                <a-radio-button value="500">
                  500元
                </a-radio-button>
                <a-radio-button value="1000">
                  1000元
                </a-radio-button>
                <a-radio-button value="2000">
                  2000元
                </a-radio-button>
                <a-radio-button value="-1">
                  自定义
                </a-radio-button>
              </a-radio-group>
              <a-input-number :min="100" :max="5000000" placeholder="投放金额" v-model="diyamountcopy" v-if="amount == '-1'"
                class="cpa_bid" />
            </div>
          </div>
        </a-form-item>
        <a-form-item label="复制笔数">
          <a-input-number v-model="copynum" class="copynum" :min="1" :max="100" />
        </a-form-item>

        <a-form-item label="投放时间">
              <a-radio-group :value="dotype" @change="handleDotimeChange">
                <a-radio-button value="NOW">
                  立即投放
                </a-radio-button>
                <a-radio-button value="SET">
                  定时投放
                </a-radio-button>
              </a-radio-group>

              <a-date-picker style="margin-left: 10px;" class="dotime" v-if="dotype == 'SET'" v-model="dotime" show-time 
                placeholder="设置投放时间"  :disabledDate="disabledDate"  :disabledTime="disabledDateTime" 
                :defaultValue="defaultTime" format="YYYY-MM-DD HH:mm:ss"/>

        </a-form-item>

        <a-form-item label="分批投放">

          <a-radio-group :value="is_batch" @change="handleBatchChange">
                <a-radio-button value="0">
                  否
                </a-radio-button>
                <a-radio-button value="1">
                  是
                </a-radio-button>
              </a-radio-group>

              <span v-if="is_batch == '1'" class="jgtf" style="margin-left: 10px;">
                每隔<a-input-number :min="1" :max="120" placeholder="分钟间隔" v-model="interval_time" class="interval_time" style="margin-left: 10px;"/>
                分钟投放
                <a-input-number :min="1" :max="copynum" placeholder="投放笔数" v-model="tfnum" class="interval_time" /> 笔
              </span>

        </a-form-item>

        <a-form-item label="计划标签">
          <a-input placeholder="给创建出的计划打标签" v-model="tags" style="width: 200px;"/>  （ 选填 ）
        </a-form-item>

        <a-form-item label="计划加白">
          <a-switch checked-children="开" un-checked-children="关"  :checked="is_white"  @change="is_white = !is_white"/>
              （ 创建出的计划加白后将不会执行监控规则 ）
        </a-form-item>


      </a-form>
    </a-modal>


    
    <a-modal v-if="commissionVisible" v-model="commissionVisible" title="设置商品佣金" width="800px" okText="设置" @ok="setCommissionSubmit"
      :zIndex="1002">
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <!-- <a-form-item label="计划ID">
          <b>{{ ad.order_id }}</b>
        </a-form-item>  -->
        <a-form-item label="视频信息"> 
          <div class="product-item">
            <div class="byted-popover-wrapper">
              <div class="good">
                <img @click="govideo(ad)" :src="ad.aweme_item_cover" alt="商品图片" class="copy-icon" />
              </div>
            </div>
            <div class="info">
              <p class="name">
                {{ ad.aweme_item_title }}
              </p> 
              <span class="id"><img :src="ad.aweme_avatar" style="width: 20px;height: 20px;border-radius: 50%;"/> {{ ad.aweme_name }}({{ad.aweme_item_id}})  | 视频ID：{{ ad.video_info_aweme_item_id }}</span> 
            </div>
          </div>  
        </a-form-item>
        <a-form-item label="商品信息">
          <div class="product-item" v-if="order_detail.product_info">
            <div class="byted-popover-wrapper">
              <div class="good">
                <img :src="order_detail.product_info.img" alt="商品图片" class="icon" />
              </div>
            </div>
            <div class="info">
              <p class="name">
                {{ order_detail.product_info.name }}
              </p>
              <span class="id">商品ID {{ order_detail.product_info.id }}</span><span class="separator"></span><span
                class="price">
                价格<span class="price-num">
                  {{ order_detail.product_info.discount_lower_price }}
                  <span>
                    - {{ order_detail.product_info.discount_higher_price }}
                  </span></span>
                元
              </span>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="商品佣金"  v-if="order_detail.product_info">
          <a-input-number v-model="commission_rate" class="copynum" :min="1" :max="100" /> （百分比）
          <b style="color:#ff7614">预估赚：{{ (order_detail.product_info.discount_lower_price*commission_rate/100).toFixed(2) }} ~ {{ (order_detail.product_info.discount_higher_price*commission_rate/100).toFixed(2) }} 元</b>
        </a-form-item>
        <a-form-item label="退货率">
          <a-input-number v-model="return_rate" class="copynum" :min="1" :max="100" /> （百分比） 不知道退货率？<a @click="returnRateVisible=true">退货率参考</a>
        </a-form-item>
        <a-form-item label="预估保本ROI" v-if="order_detail.product_info">
          <b style="color: green;margin-right: 10px">
            {{ ( order_detail.product_info.discount_lower_price/(order_detail.product_info.discount_lower_price*commission_rate/100) ).toFixed(2) }} </b> <a @click="roiCalculatorVisible = true">ROI保本计算器</a>
          
        </a-form-item>

        <a-form-item label="结算保本ROI" v-if="order_detail.product_info"> 
          <b style="color: green">
            {{ ( order_detail.product_info.discount_lower_price/(order_detail.product_info.discount_lower_price*commission_rate/100*(1-return_rate/100-0.1)) ).toFixed(2) }}</b>
            （ 扣除退货率 和 抖音平台手续费后)
        </a-form-item>
        
        <a-form-item label="计算规则">
          <p>（ 盈亏金额 = 成交订单金额*商品佣金比(1-退货率-抖音平台手续费10%)-消耗金额 ）</p> 
          <p>（ 预估保本ROI = 商品价格/（商品价格*商品佣金比） ）</p> 
          <p>（ 结算保本ROI = 商品价格/（商品价格*商品佣金比(1-退货率-抖音平台手续费10%)） ）</p> 
        </a-form-item>
      </a-form>
    </a-modal>




    <a-modal v-if="closevisible" v-model="closevisible" title="批量关停计划" width="1050px" :okText="okText" @ok="stopAll"
      :zIndex="1001">
      <div class="authTypeWapper">
        <div class="tips">
          关停计划需要满足满足以下任一条件即可:【订单审核中超2小时、直播预约订单暂未开播、订单投放中且消耗超过20%】<br />
        
        </div>
        <a-table :columns="selectedcolumns" :data-source="stopData" :rowKey="(record) => record.ad_id" :pagination="false"
          :scroll="{ y: 540 }">
          <a slot="name" slot-scope="text">{{ text }}</a>
          <img slot="aweme_item_cover" slot-scope="text, record" @click="govideo(record)" class="videoimg" :src="text"
            v-if="text" />
          <a-tag slot="stop_status" slot-scope="text" v-if="text == '待执行'">{{
            text
          }}</a-tag>
          <a-tag color="green" slot="stop_status" slot-scope="text" v-else-if="text == '关停成功'">{{ text }}</a-tag>
          <a-tag color="red" slot="stop_status" slot-scope="text" v-else>{{
            text
          }}</a-tag>
          <span style="cursor: pointer;color: #1890ff;" slot="cancel"  slot-scope="text"  @click="cancelSelect(text,1)" >移除</span>

        </a-table>
        <a-progress :percent="(count / stopData.length) * 100" size="small" />
        <div class="tips">
          <a-alert :message="stoptip" banner type="info" show-icon/>
        </div>
      </div>
    </a-modal>


    <a-modal v-if="ztvisible" v-model="ztvisible" title="批量追投计划" width="1050px" :okText="okText" @ok="ztAll"
      :zIndex="1002">
      <div class="authTypeWapper">
        <div class="tips">
         投放中的计划可进行追投操作。 <br />
        
        </div>
        <a-table :columns="selectedcolumns" :data-source="ztData" :rowKey="(record) => record.ad_id" :pagination="false"
          :scroll="{ y: 540 }">
          <a slot="name" slot-scope="text">{{ text }}</a>
          <img slot="aweme_item_cover" slot-scope="text, record" @click="govideo(record)" class="videoimg" :src="text"
            v-if="text" />
          <a-tag slot="stop_status" slot-scope="text" v-if="text == '待执行'">{{
            text
          }}</a-tag>
          <a-tag color="green" slot="stop_status" slot-scope="text" v-else-if="text == '追投成功'">{{ text }}</a-tag>
          <a-tag color="red" slot="stop_status" slot-scope="text" v-else>{{
            text
          }}</a-tag>
          <span style="cursor: pointer;color: #1890ff;" slot="cancel"  slot-scope="text"  @click="cancelSelect(text,2)" >移除</span>

        </a-table>

        <div class="form-item-container horizontal">
        <div>
          <div class="title-box level-2 normal">延长的投放时间 (参考系统建议,续费金额不高于3倍，设置的投放金额过大，可能造成订单超成本。) </div>
          <div class="external-action-wrapper" style="text-align: left;">
            <a-radio-group :value="renewal_delivery_seconds" @change="handleRenewalDeliverySecondsChange">
              <a-radio-button value="0">
                0天
              </a-radio-button>
              <a-radio-button value="1">
                1天
              </a-radio-button>
              <a-radio-button value="2">
                2天
              </a-radio-button>
              <a-radio-button value="3">
                3天
              </a-radio-button>
              <a-radio-button value="4">
                4天
              </a-radio-button>
              <a-radio-button value="5">
                5天
              </a-radio-button>
              <a-radio-button value="6">
                6天
              </a-radio-button>
              <a-radio-button value="7">
                7天
              </a-radio-button>
            </a-radio-group>
          </div> 
          <div class="title-box level-2 normal">追加的预算 (参考系统建议,投放时间不低于3倍，设置的投放时间过短，可能造成订单超成本。)</div>
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">
              <a-radio-group :value="renewal_budget" @change="handleRenewalBudgetChange">
                <a-radio-button value="100">
                  100元
                </a-radio-button>
                <a-radio-button value="200">
                  200元
                </a-radio-button>
                <a-radio-button value="500">
                  500元
                </a-radio-button>
                <a-radio-button value="1000">
                  1000元
                </a-radio-button>
                <a-radio-button value="2000">
                  2000元
                </a-radio-button>
                <a-radio-button value="-1">
                  自定义
                </a-radio-button>
              </a-radio-group>
              <a-input-number :min="10" :max="5000000" placeholder="最低10元" v-model="diyamount" v-if="renewal_budget == '-1'"
                class="cpa_bid" />
            </div>
          </div>

          

        </div>
      </div>


        <a-progress :percent="(count / ztData.length) * 100" size="small" /> 
      </div>
    </a-modal>

    <!-- <a-modal v-if="downvisible" v-model="ztvisible" title="按日消耗下载" width="1050px" :okText="okText" @ok="ztAll"
      :zIndex="1002">
      <div class="authTypeWapper">
        <div class="tips">
          选择具体消耗的时间可导出当天每笔计划消耗的具体情况<br /> 
        </div>  
        <div class="form-item-container horizontal">
        <div>
          <div class="title-box level-2 normal">选择需要导出报表的时间 </div>
          <div class="external-action-wrapper" style="text-align: left;">
            <a-date-picker @change="ondoChange" />
          </div> 

          

        </div>
      </div> 
      </div>
    </a-modal> -->

    <a-modal v-if="columnsVisible" v-model="columnsVisible" title="自定义数据" width="1050px" okText="确定" @ok="onColumnOk"
      :zIndex="1001">
      <div class="authTypeWapper">
        <div class="tips"> 
          <a-alert message="最少可选择3项，最多可选择20项" banner type="info" show-icon/>  
        </div>  
      </div>
      <div style="width: 100%;height: 350px;margin-bottom: 30px;border: 1px solid #e5e5e5;">
        <div class="dialog-left">
          <ul>
            <li>基础效果</li>
            <li>成交转化</li>
            <li>互动效果</li>
          </ul>
        </div>
        <div class="dialog-center">
          <div class="dialog-center-title">基础效果</div>
          <ul>
            <li><a-checkbox  :checked="getChecked('stat_cost')" @change="onColumnChange($event,'stat_cost')" :disabled="true">消耗</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('show_cnt')" @change="onColumnChange($event,'show_cnt')">展示次数</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('ctr')" @change="onColumnChange($event,'ctr')">点击率</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('cpm_platform')" @change="onColumnChange($event,'cpm_platform')">千次展示费用</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('click_cnt')" @change="onColumnChange($event,'click_cnt')">点击次数</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('total_play')" @change="onColumnChange($event,'total_play')">播放次数</a-checkbox></li> 
          </ul>
        <div style="clear: both;"></div>
          <div class="dialog-center-title">成交转化</div>
          <ul>
            <li> <a-checkbox :checked="getChecked('pay_order_count')" @change="onColumnChange($event,'pay_order_count')">成交订单数</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('pay_order_amount')" @change="onColumnChange($event,'pay_order_amount')"  :disabled="true">成交金额</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('prepay_and_pay_order_roi')" @change="onColumnChange($event,'prepay_and_pay_order_roi')"  :disabled="true">支付ROI</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('convert_cnt')" @change="onColumnChange($event,'convert_cnt')">转化数</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('convert_cost')" @change="onColumnChange($event,'convert_cost')">转化成本</a-checkbox></li> 
        
          </ul>
          <div style="clear: both;"></div>
          <div class="dialog-center-title">互动效果</div>
          <ul>
            <li> <a-checkbox :checked="getChecked('dy_follow')" @change="onColumnChange($event,'dy_follow')">新增粉丝数</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('dy_share')" @change="onColumnChange($event,'dy_share')">分享次数</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('dy_comment')" @change="onColumnChange($event,'dy_comment')">评论次数</a-checkbox></li> 
            <li> <a-checkbox :checked="getChecked('dy_like')" @change="onColumnChange($event,'dy_like')">点赞次数</a-checkbox></li>  
            <li> <a-checkbox :checked="getChecked('dy_home_visited')" @change="onColumnChange($event,'dy_home_visited')">主页访问数</a-checkbox></li> 
          </ul>
        </div>
        <div class="dialog-right"> 
          <div class="dialog-center-title">已选数据</div>
          <ul>
            <div v-for="item in columns" :key="item.key"  >
              <li v-if="item.key!='stat_cost' && item.key!='pay_order_amount' && item.key!='prepay_and_pay_order_roi' && item.key!='ad_switch' && item.key!='ad' && item.key!='aweme' && item.key!='status_text' && item.key!='delivery_setting' && item.key!='operation' && item.key!='commission_rate' && item.key!='profit_and_loss' && item.key!='return_rate_info' ">
                {{item.title}}<span><a-icon type="close-circle"  @click='delSelect(item.key)'/></span> 
              </li> 
            </div>
          </ul> 
        </div> 
        <div style="clear: both;"></div>
      </div>
    </a-modal> 


    <a-modal v-if="adEchartVisible" v-model="adEchartVisible" title="计划趋势数据" width="1200px" okText="确定" @ok="selectOk"
      zIndex=1001>
      <div  class="yAxis">
              <div>
                <section class="yAxis1" />
                <a-select v-model="adlineChartData.yAxis1" style="width: 150px" placeholder="请选择" @change="adchangeAxis1">
                  <a-select-option v-for="item in adyAxis1options" :key="item.value"  :value="item.value"
                    :disabled="item.disabled" >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
 
              </div>
              <div>
                <section class="yAxis2" />
                <a-select v-model="adlineChartData.yAxis2" style="width: 150px" placeholder="请选择" @change="adchangeAxis2">
                  <a-select-option v-for="item in adyAxis2options" :key="item.value"  :value="item.value"
                    :disabled="item.disabled" >
                    {{ item.label }}
                  </a-select-option>
                </a-select> 
              </div>
            </div>

            <a-spin :spinning="adloading" tip="加载中...">
              <line-chart :chart-data="adlineChartData" /> 
                <a-table ref="inOrderTable" :columns="adcolumns" :data-source="adtableData"  :pagination="false" :scroll="{ y:400 }" :rowKey="(record) => record.id || record.ad_id"> 
                </a-table>
            </a-spin>

    </a-modal>


    <a-drawer v-if="createDrawer" class="authAccount" title="快速创建计划" width="1160px" placement="right" :visible="createDrawer"
      @close="createDrawer = false"  :bodyStyle="{overflow: 'auto', height: 'calc(100% - 10px)'}">
       <createOrder v-if="createDrawer"  :marketing_goal="marketing_goal" :select_video_info="select_video_info"/>
    </a-drawer>

    <RoiCalculator :discount_lower_price="order_detail.product_info.discount_lower_price" :commission_rate="commission_rate||100" :return_rate="return_rate||10"  v-if="roiCalculatorVisible" @closeRoiVisible="roiCalculatorVisible=false"/>
    <ReturnRate  v-if="returnRateVisible" @closeReturnRateVisible="returnRateVisible=false"/>


  </div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import { LineChart,ReportChart } from '@components';
import { Modal } from 'ant-design-vue';
import createOrder from '../../../batchCreatePlan/index';
import Planlist from "../../../planManage/components/list.vue" 
import RoiCalculator from "./components/roi.vue"
import ReturnRate from "./components/return.vue"
import moment from 'moment';
import * as echarts from 'echarts'
const columns = [
  {
    title: '计划信息',
    key: 'ad',
    width: 240,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'ad' },
    sorter: true,
    fixed: 'left',
  },
  {
    title: '投放视频',
    key: 'aweme',
    width: 300,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'aweme' },
    // fixed: 'left',
  },
  {
    title: '计划状态',
    dataIndex: 'status_text',
    key: 'status_text',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'status_text' },
  },
  // {
  //   title: '投放金额（元）',
  //   dataIndex: 'delivery_setting_amount',
  //   key: 'delivery_setting_amount',
  //   align: 'center',
  //   width: 130,
  //   sorter: true,
  // },
  {
    title: '投放金额（元）',
    key: 'delivery_setting',
    align: 'left',
    width: 180,
    sorter: true,
    scopedSlots: { customRender: 'delivery_setting' },
  }, 
  {
    title: '消耗（元）',
    dataIndex: 'stat_cost',
    key: 'stat_cost',
    align: 'center',
    width: 130,
    sorter: true,
  },
  {
    title: '成交金额',
    dataIndex: 'pay_order_amount',
    key: 'pay_order_amount',
    align: 'center',
    width: 130,
    sorter: true,
  },
  {
    title: '支付ROI',
    // dataIndex: 'prepay_and_pay_order_roi',
    key: 'prepay_and_pay_order_roi',
    align: 'center',
    width: 130,
    sorter: true,
    scopedSlots: { customRender: 'prepay_and_pay_order_roi' },
  },
  {
    title: '商品佣金率', 
    key: 'commission_rate',
    width: 130,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'commission_rate' }, 
  }, 
  {
    title: '实际盈亏',
    dataIndex: 'profit_and_loss',
    key: 'profit_and_loss',
    width: 130,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'profit_and_loss' }, 
  }, 
  {
    title: '保本ROI', 
    key: 'return_rate_info',
    width: 130,
    align: 'center', 
    ellipsis: true,
    scopedSlots: { customRender: 'return_rate_info' }, 
  },
  {
    title: '成交订单数',
    dataIndex: 'pay_order_count',
    key: 'pay_order_count',
    align: 'center',
    width: 130,
    sorter: true,
  },
  {
    title: '播放次数',
    dataIndex: 'total_play',
    key: 'total_play',
    align: 'center',
    width: 130,
    sorter: true,
  },
  {
    title: '展示次数',
    dataIndex: 'show_cnt',
    key: 'show_cnt',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '点击率',
    dataIndex: 'ctr',
    key: 'ctr',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '点击次数',
    dataIndex: 'click_cnt',
    key: 'click_cnt',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '新增粉丝数',
    dataIndex: 'dy_follow',
    key: 'dy_follow',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '分享次数',
    dataIndex: 'dy_share',
    key: 'dy_share',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '评论次数',
    dataIndex: 'dy_comment',
    key: 'dy_comment',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '点赞次数',
    dataIndex: 'dy_like',
    key: 'dy_like',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '转化数',
    dataIndex: 'convert_cnt',
    key: 'convert_cnt',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '转化成本',
    dataIndex: 'convert_cost',
    key: 'convert_cost',
    align: 'center',
    sorter: true,
    width: 130,
  },
  {
    title: '主页访问数',
    dataIndex: 'dy_home_visited',
    key: 'dy_home_visited',
    align: 'center',
    sorter: true,
    width: 130,
  }, 
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];
const adcolumns = [
  {
    title: '时间',
    dataIndex: 'stat_datetime',
    width: 200,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'stat_datetime' },
    fixed: 'left',
  },  
  {
    title: '消耗（元）',
    dataIndex: 'stat_cost',
    key: 'stat_cost',
    align: 'center',
    width: 130, 
  },
  {
    title: '成交金额',
    dataIndex: 'pay_order_amount',
    key: 'pay_order_amount',
    align: 'center',
    width: 130, 
  },
  {
    title: '支付ROI',
    dataIndex: 'prepay_and_pay_order_roi',
    key: 'prepay_and_pay_order_roi',
    align: 'center',
    width: 130, 
    scopedSlots: { customRender: 'prepay_and_pay_order_roi' },
  },
  {
    title: '成交订单数',
    dataIndex: 'pay_order_count',
    key: 'pay_order_count',
    align: 'center',
    width: 130, 
  },
  {
    title: '播放次数',
    dataIndex: 'total_play',
    key: 'total_play',
    align: 'center',
    width: 130, 
  },
  {
    title: '展示次数',
    dataIndex: 'show_cnt',
    key: 'show_cnt',
    align: 'center', 
    width: 130,
  },
  {
    title: '点击率',
    dataIndex: 'ctr',
    key: 'ctr',
    align: 'center', 
    width: 130,
  }, 
];
const selectedcolumns = [
  {
    title: '计划ID',
    dataIndex: 'order_id',
    key: 'order_id',
    width: 185,
    scopedSlots: { customRender: 'order_id' },
  },
  {
    title: '视频标题',
    dataIndex: 'aweme_item_title',
    key: 'aweme_item_title',
    scopedSlots: { customRender: 'aweme_item_title' },
  },
  {
    title: '计划状态',
    dataIndex: 'status_text',
    width: 120,
    key: 'status_text',
    align: 'center',
    scopedSlots: { customRender: 'status_text' },
  },
  {
    title: '消耗',
    dataIndex: 'stat_cost',
    key: 'stat_cost',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'stat_cost' },
  },
  {
    title: '成交金额',
    dataIndex: 'pay_order_amount',
    key: 'pay_order_amount',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'pay_order_amount' },
  },
  {
    title: 'ROI',
    dataIndex: 'prepay_and_pay_order_roi',
    key: 'prepay_and_pay_order_roi',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'prepay_and_pay_order_roi' },
  },
  {
    title: '执行状态',
    dataIndex: 'stop_status',
    align: 'center',
    key: 'stop_status',
    width: 250,
    scopedSlots: { customRender: 'stop_status' },
  },
  {
    title: '移除', 
    key: 'cancel',
    align: 'center', 
    scopedSlots: { customRender: 'cancel' },
  },
];
const user_log_columns = [
  {title: '操作时间',dataIndex: 'createtime',key: 'createtime',width: 90},
  {title: '操作内容',key: 'content',dataIndex: 'content',width: 200}, 
  {title: '操作人',dataIndex: 'nickname',key: 'nickname',width: 90}
];
const monitor_log_columns = [
  { title: '户ID', dataIndex: 'advertiser_id', key: 'advertiser_id', width: 180 },
  { title: '计划ID', dataIndex: 'order_id', key: 'order_id', width: 180 },
  { title: '监控类型', dataIndex: 'type_text', key: 'type_text', width: 130 },
  { title: '监控反馈', dataIndex: 'content', key: 'content' },
  { title: '创建时间', dataIndex: 'createtime', key: 'createtime', width: 150 },
];
const data = [];
const key = 'updatable';
export default {
  name: 'ShowTemplate',
  props: {
    advertiser_id: {
      type: String,
      default: '',
    },
    marketing_goal: {
      type: String,
      default: '',
    }, 
    video_info_aweme_item_id:{
      type: String,
      default: '',
    }, 
    product_id:{
      type: String,
      default: '',
    }, 
    aweme_info_aweme_id:{
      type: String,
      default: '',
    }
  },

  data() {
    return {
      spinning: false,
      closevisible: false,
      columns,
      selectedcolumns,
      lasttime: '-',
      orderDrawer: false,
      data,
      status: '', // 分页参数
      report: {},
      pagination: {
        // size: 'large',
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30','40','100'], // 可选的页面显示条数
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        }, // 展示每页第几条至第几条和总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true, // 是否可以改变pageSize
      },
      page: 1,
      pagesize: 10,
      selectedRow: [],
      selectedRowKeys: [],
      statusData: [
        { name: '全部计划状态', value: '' },
        { name: '投放中', value: 'DELIVERY_OK' },
        { name: '定时投放', value: 'SET' },
        { name: '长期投放', value: 'LONG' },
        { name: '分批投放', value: 'BATCH' },
        { name: '定时分批', value: 'SETBATCH' },
        { name: '审核中', value: 'AUDIT' },
        { name: '未开播', value: 'BOOK' },
        { name: '计划创建中', value: 'CREATING' },
        { name: '计划创建失败', value: 'FAILED' },
        { name: '投放完成', value: 'FINISHED' },
        { name: '投放终止', value: 'FROZEN' },
        { name: '审核不通过', value: 'OFFLINE_AUDIT' },
        { name: '投放结束', value: 'OVER' },
        { name: '订单关闭', value: 'TIMEOUT' },
        { name: '未支付', value: 'UNPAID' },
        { name: '未支付取消订单', value: 'UNPAIDCANCEL' },
      ],
      targetData:[
        { name: '全部优化目标', value: '' },
        { name: '商品购买', value: 'AD_CONVERT_TYPE_SHOPPING' },
        { name: '粉丝提升', value: 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION' },
        { name: '点赞评论', value: 'AD_CONVERT_TYPE_QC_MUST_BUY' },
        { name: '商品支付ROI', value: 'AD_CONVERT_TYPE_LIVE_ROI' },
      ],
      // AD_CONVERT_TYPE_QC_FOLLOW_ACTION: 粉丝提升
      // AD_CONVERT_TYPE_QC_MUST_BUY: 点赞评论
      // AD_CONVERT_TYPE_SHOPPING: 商品购买
      delivery_setting_external_action:'',
      order_detail: {},
      ad: {},
      onfirmLoading: false,
      dataMap: {},
      stopData: [],
      count: 0,
      okText: '一键批量关停订单',
      copyVisible: false,
      deadline: Date.now() + 1000 * 31,
      deadtitle: '定时刷新中：倒计时',
      sortby: 'ad_id',
      sort: 'descend',
      order_id: '',
      timeType: 'ALL',
      range_date:[moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
      timeday:'0',
      tfz_tab:'投放中计划',
      stoptip:'每日终止配额：- 笔 今日终止订单数：- 笔 今日剩余终止订单数量：- 笔',
      selectVisible:false,
      toploading:false,
      lineChartData: {
        expectedData: [],
        actualData: [],
        yAxis1: '消耗',
        yAxis2: '展示次数',
        xAxisdata: []
      },
      lineProductChartData: {
        expectedData: [],
        actualData: [],
        yAxis1: '',
        yAxis2: '',
        xAxisdata: []
      },
      adlineChartData: {
        expectedData: [],
        actualData: [],
        yAxis1: '消耗',
        yAxis2: '展示次数',
        xAxisdata: []
      },
      yAxis1options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: false
        },
        {
          value: '1',
          name: 'show_cnt',
          label: '展示次数',
          disabled: false
        },
        {
          value: '2',
          name: 'click_cnt',
          label: '点击次数',
          disabled: false
        },
        {
          value: '3',
          name: 'ctr',
          label: '点击率',
          disabled: false
        }, 
        {
          value: '4',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: true
        },
        {
          value: '5',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false
        },
        {
          value: '6',
          name: 'pay_order_count',
          label: '成交订单数',
          disabled: false
        }  
      ],
      yAxis2options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: true
        },
        {
          value: '1',
          name: 'show_cnt',
          label: '展示次数',
          disabled: false
        },
        {
          value: '2',
          name: 'click_cnt',
          label: '点击次数',
          disabled: false
        },
        {
          value: '3',
          name: 'ctr',
          label: '点击率',
          disabled: false
        }, 
        {
          value: '4',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: false
        },
        {
          value: '5',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false
        }, 
        {
          value: '6',
          name: 'pay_order_count',
          label: '成交订单数',
          disabled: false
        } 
      ],
      adyAxis1options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: false
        },
        {
          value: '1',
          name: 'show_cnt',
          label: '展示次数',
          disabled: false
        },
        {
          value: '2',
          name: 'click_cnt',
          label: '点击次数',
          disabled: false
        },
        {
          value: '3',
          name: 'ctr',
          label: '点击率',
          disabled: false
        }, 
        {
          value: '4',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: false
        },
        {
          value: '5',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false
        }, 
      ],
      adyAxis2options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: true
        },
        {
          value: '1',
          name: 'show_cnt',
          label: '展示次数',
          disabled: false
        },
        {
          value: '2',
          name: 'click_cnt',
          label: '点击次数',
          disabled: false
        },
        {
          value: '3',
          name: 'ctr',
          label: '点击率',
          disabled: false
        }, 
        {
          value: '4',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: false
        },
        {
          value: '5',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false
        }, 
        {
          value: '6',
          name: 'pay_order_count',
          label: '成交订单数',
          disabled: false
        } 
      ],
      yAxis1name:'',
      yAxis2name:'',
      topkey:1,
      adEchartVisible:false, 
      adyAxis1name:'',
      adyAxis2name:'',
      adloading:false,
      adtableData:[],
      adcolumns,
      advertisertableData:[],
      downmonth:'',
      commissionVisible:false,

      copynum: 1,
      commission_rate:'',
      dotime: '',
      dotype: 'NOW',
      times: 1,
      is_batch: '0',
      interval_time: '5',
      tfnum: '1',
      remark:'',
      timer_status:true,
      tags:'',
      is_white:false,
      ztvisible:false,
      ztData:[],
      renewal_budget:'100',
      renewal_delivery_seconds:'2',
      diyamount:'',
      showToday:false,
      productDrawer:false,
      productDetail:{},
      productloading:false,
      productnav:1,
      product_x:[],
      product_y:[],
      product_kol_num_y:[],
      product_order_num_y:[],
      product_view_num_y:[],
      product_bfzhl_y:[],
      product_rjzhl_y:[],
      product_rjbfl_y:[],
      //复制相关
      external_action:'',
      bid_mode:'',
      delivery_time:'',
      bid_type:'', 
      cpa_bid:'',
      roi_goal:'',
      amount:'',
      diyamountcopy:'',
      
      createDrawer:false,
      select_video_info:[],
      wait_create:0,

      
      xData:[],
      y1:[],
      y2:[],
      y3:[],
      y4:[],
      y5:[],
      y6:[], 
      
      return_rate:10,
      roiCalculatorVisible:false,
      returnRateVisible:false,
      columnsVisible:false,

      search_remark:'',
      detailTab:'1',
      
      user_log_columns,
      user_log_data:[],
      monitor_log_columns,
      monitor_log_data:[],


      distributionMetric: 'stat_cost',
      // 图表实例
      myChart1: null,
      myChart2: null,
      circleIndex:'VIDEO',
      circleData:{},

    };
  },

  components: {
    LineChart,
    ReportChart,
    createOrder,
    planlist:Planlist,
    RoiCalculator,
    ReturnRate
  },

  computed: {
    chartOptions() {
      return {
        trend: {
          animation: false,
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [this.lineChartData.yAxis1, this.lineChartData.yAxis2],
            bottom: '0'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '40px',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: this.lineChartData.xAxisdata || []
          },
          yAxis: [{
            type: 'value',
            name: '数值',
            axisLabel: {
              formatter: (value) => {
                if (this.lineChartData.yAxis1.includes('roi') || this.lineChartData.yAxis2.includes('roi')) {
                  return value;
                }
                return `￥${value}`;
              }
            }
          }],
          series: [{
            name: this.lineChartData.yAxis1,
            data: this.lineChartData.actualData || [],
            type: 'line',
            smooth: true
          }, {
            name: this.lineChartData.yAxis2,
            data: this.lineChartData.expectedData || [],
            type: 'line',
            smooth: true
          }]
        },
        distribution: {
          animation: false,
          tooltip: {
            trigger: 'item',
            formatter: (params) => {
              let value;
              if (this.distributionMetric === 'pay_order_count') {
                value = `${params.value} 个`;
              } else {
                value = `¥${params.value.toFixed(2)}`;
              }
              return `${params.name}\n${this.getDistributionMetricName(this.distributionMetric)}: ${value}\n占比: ${params.percent}%`;
            }
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 'center',
            type: 'scroll',
            formatter: (name) => {
              if (name.length > 12) {
                return name.substring(0, 12) + '...';
              }
              return name;
            }
          },
          series: [{
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              formatter: (params) => {
                const name = params.name.length > 8 ? params.name.substring(0, 8) + '...' : params.name;
                return `${name}\n${params.percent}%`;
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.circleData || []
          }]
        }
      }
    }
  },
  watch: {
    advertiser_id(a, b) {
      this.page = 1
      this.order_id = ''
      this.search_remark = ''
      this.pagination.current = 1
      console.log(a, b);
      this.getData();
      if(this.topkey == 1){
        this.getReport()
      }else{
        this.GraphData()
        this.getCircleData()
      }
      this.selectedRowKeys = []
    },
    video_info_aweme_item_id(a,b){ 
      console.log(a, b);
      this.page = 1
      this.order_id = ''
      this.search_remark = ''
      this.pagination.current = 1
      this.getData();
      if(this.topkey == 1){
        this.getReport()
      }else{ 
        this.GraphData()
        this.getCircleData()
      }
      this.selectedRowKeys = []
    },
    product_id(a,b){ 
      console.log(a, b);
      this.page = 1
      this.order_id = ''
      this.search_remark = ''
      this.pagination.current = 1
      this.getData();
      if(this.topkey == 1){
        this.getReport()
      }else{
        this.GraphData()
        this.getCircleData()
      }
      this.selectedRowKeys = []
    },
    aweme_info_aweme_id(a,b){ 
      this.page = 1
      this.order_id = ''
      this.search_remark = ''
      this.pagination.current = 1
      console.log(a, b);
      this.getData();
      if(this.topkey == 1){
        this.getReport()
      }else{
        this.GraphData()
        this.getCircleData()
      }
      this.selectedRowKeys = []
    },
    distributionMetric: {
      handler() {
        this.getCircleData()
        this.updateCharts()
      }
    }
  },
  async mounted() { },
  methods: { 
    moment,
    getVidioItem(item){
      this.$emit('getVidioItem',item)
    },
    getAwemeItem(item){
      this.$emit('getAwemeItem',item)
    },
    changeDetailTopTab(e){
      this.detailTab = e
      if(e == 3){ 
        this.getUserLog()
      }else if(e == 4){ 
        this.getMonitorLog()
      }
    },
    async getUserLog() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_USER_LOGLIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          other_id: this.order_detail.order_id,
          page: 1,
          pagesize:100,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return; 
      this.user_log_data = data.list; 
    },
    async getMonitorLog() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_SXT_MONITOR_LOG_LIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          order_id: this.order_detail.order_id,
          page: 1,
          pagesize:100,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return; 
      this.monitor_log_data = data.list; 
    },
    async onColumnOk(){
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SER_AD_COLUMNS}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id, 
          type:'SXT',
          marketing_goal:this.marketing_goal,
          ad_columns:JSON.stringify(this.columns)
        },
      }); 
      if (code == 0) {
        this.$message.error(msg);
        return;
      } 
      this.columnsVisible=false
      this.getData()
    },
    onColumnChange(e,type){
      if(!e.target.checked){
        console.log('选中状态',e)
        console.log('选中字段',type)
        this.columns = this.columns.filter(function(item){
          return item.key != type
        })
      }else{
        let data = {}
        if(type == 'raise'){
          data = {
            title: this.getTitle(type), 
            key: type,
            align: 'center',
            width: 200, 
            scopedSlots: { customRender: type},
          }
        }else{
          data = {
            title: this.getTitle(type),
            dataIndex: type,
            key: type,
            align: 'center',
            width: 120,
            sorter: true,
          }
        }
        this.columns.splice(this.columns.length - 1, 0,data);
      }
      console.log(this.columns);
      this.$forceUpdate()
    },
    delSelect(type){
      this.columns = this.columns.filter(function(item){
        return item.key != type
      })
    },
    getTitle(type){
      let title = ''
      switch (type) {
        case 'stat_cost':
          title = '消耗（元）'
          break;
        case 'pay_order_amount':
          title = '成交金额'
          break;
        case 'prepay_and_pay_order_roi':
          title = '支付ROI'
          break;
        case 'pay_order_count':
          title = '成交订单数'
          break;
        case 'total_play':
          title = '播放次数'
          break;
        case 'show_cnt':
          title = '展示次数'
          break;
        case 'ctr':
          title = '点击率'
          break;
        case 'cpm_platform':
          title = '千展费用'
          break;
        case 'click_cnt':
          title = '点击次数'
          break;
        case 'convert_cnt':
          title = '转化数'
          break;
        case 'convert_cost':
          title = '转化成本'
          break;
        case 'dy_follow':
          title = '新增粉丝数'
          break;
        case 'dy_share':
          title = '分享次数'
          break;
        case 'dy_comment':
          title = '评论次数'
          break;
        case 'dy_like':
          title = '点赞次数'
          break;
        case 'dy_home_visited':
          title = '主页访问数'
          break;
        default:
          break;
      }
      return title
    },
    getChecked(type){
      let status = false
      for (let i = 0; i < this.columns.length; i++) {
        if(this.columns[i].key == type){
          status = true
        }
      }
      return status
    },
    cancelSelect(text,type){ 
      if(type == 1){
        this.stopData = this.stopData.filter(function(item){
            return item.order_id != text.order_id
        })
      }else{
        this.ztData = this.ztData.filter(function(item){
            return item.order_id != text.order_id
        })
      }
    },
    disabledDate (current) {
      return current && current <  this.$moment().subtract(1, 'days').endOf('day')
    }, 
    handleRenewalDeliverySecondsChange(e){ 
      this.renewal_delivery_seconds = e.target.value;
    },
    handleRenewalBudgetChange(e){ 
      this.renewal_budget = e.target.value;
    },
    checkNav(nav){
      this.productnav = nav
      let yAxis2 ='销量'
      if(nav == 1){
        this.product_y = this.product_order_num_y
        yAxis2 ='销量'
      }
      if(nav == 2){
        this.product_y = this.product_view_num_y
        yAxis2 ='浏览量'
      }
      if(nav == 3){
        this.product_y = this.product_kol_num_y
        yAxis2 ='推广达人数'
      }
      if(nav == 4){
        this.product_y = this.product_bfzhl_y
        yAxis2 ='播放转化率'
      }
      if(nav == 5){
        this.product_y = this.product_rjzhl_y
        yAxis2 ='人均转化率'
      }
      if(nav == 6){
        this.product_y = this.product_rjbfl_y
        yAxis2 ='人均播放率'
      }
      this.lineProductChartData.xAxisdata = this.product_x
      this.lineProductChartData.expectedData = this.product_y
      this.lineProductChartData.yAxis2 = yAxis2
    },
    changeTimerStatus(){
      this.timer_status = !this.timer_status
      if(this.timer_status){
        this.deadline = Date.now() + 1000 * 31
      }
    },
    remarkBatch(){
     const that = this; 
     Modal.confirm({
        title: '设置备注',
        content:'是否确定批量设置选中的计划备注为'+that.remark+'？',
        onOk: () => {
          that.remarkBatchApi();
        },
      });
    },
    async remarkBatchApi(){
      console.log('备注',this.selectedRowKeys)
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_BATCH_REMARK}`,
        method: 'POST',
        params: {
          advertiser_id:this.advertiser_id,
          marketing_goal:this.marketing_goal,
          ad_ids: this.selectedRowKeys.join(','),  
          remark:this.remark
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.data = []
      this.$message.success(msg)
      this.remark = ''
      this.getData() 
    },
    // 时间禁止
    disabledDateTime (current) { 
      if(typeof(current)!='undefined'){ 
        let today = moment().date();
        if(today == current.date()){
          let minute = Number(moment().minutes())
          let hour = Number(moment().hour());
          let finalHour=0,finalMinute=0;
          if(current.hour() > hour ){
            finalMinute = 0
          }else{
            if(current.minute() >= 58){
              finalHour = hour + 1;
              finalMinute = 0; 
            }else{
              finalHour = hour;
              finalMinute = minute + 5;
            }
          }
          return {
            disabledHours: () => this.range(0, finalHour),
            disabledMinutes: () => this.range(0, finalMinute)
          }
        }else if(moment()>current){
          return {
            disabledHours: () => this.range(0, 24),
            disabledMinutes: () => this.range(0, 60),
            disabledSeconds: () => this.range(0, 60)
          }
      }
      }else{ 
        return {
          disabledHours: () => this.range(0, 24),
          disabledMinutes: () => this.range(0, 60),
          disabledSeconds: () => this.range(0, 60),
        }
      }
    },
    range (start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    }, 
    setmonitor(){
      this.$router.replace('/sxt_monitorManage');
    },
    addwhite(e,type){ 
     const that = this;
      Modal.confirm({
        title: '加白提醒',
        content: type=='add'?'是否确定加白该计划？加白后该计划后该计划将不会被监控。':'是否确定取消加白该计划？取消加白后该计划后该计划将会重新被监控。',
        onOk: () => {
          that.addwhiteAction(e, type);
        },
      });
    },
    async addwhiteAction(e,type){
      console.log('备注',e)
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_AD_WHITE}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id, 
          ad_id: e.ad_id, 
          marketing_goal:e.marketing_goal,
          order_create_day:e.order_create_day,
          type:type
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.data = []
      this.$message.success(msg)
      this.remark = ''
      this.getData() 
    },
    async setAdRemark(e){
      console.log('备注',e)
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_AD_REMARK}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id, 
          ad_id: e.ad_id, 
          marketing_goal:e.marketing_goal,
          remark:this.remark
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.data = []
      this.$message.success(msg)
      this.remark = ''
      this.getData() 
    },
    handleDotimeChange(e) {
      this.dotype = e.target.value;
      if(this.dotype == 'SET'){ 
        let date=new Date();
        let min=date.getMinutes();
        date.setMinutes(min+5);
        this.defaultTime = moment(date,'YYYY-MM-DD HH:mm:ss')
        this.dotime = this.defaultTime
      }else{
        this.defaultTime = ''
      }
    },
    async reflesh(item,status = false){
      if(status){
        this.detailTab = '1'
        this.orderDrawer = true
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_AD_DETAIL_REFELSH}`,
        method: 'POST',
        params: {
          advertiser_id: item.advertiser_id,
          order_id: item.order_id,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if(status){
        this.ad = item;
        this.order_detail = data
      }else{
        this.getData()
      }
    },
    handleBatchChange(e) {
      console.log(e)
      this.is_batch = e.target.value
    },
    async  getDetailByAd(){
      await this.getDetail(this.data[0],'rate')
    }, 
    onChangeMonth(date,dateString){
      console.log(dateString)
      this.downmonth = dateString
    },
    getadEchart(e){
      this.ad = e;
      this.adlineChartData.yAxis1 = this.adyAxis1options[0].label
      this.adyAxis1name = this.adyAxis1options[0].name
      this.adlineChartData.yAxis2 = this.adyAxis2options[4].label
      this.adyAxis2name = this.adyAxis2options[4].name
      this.echartOrder(e)
    },
    async echartOrder(e){
      this.adloading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_AD_REPORT_ECHART}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          ad_id: e.ad_id,
          order_create_time:e.order_create_time,
          y1: this.adyAxis1name,
          y2: this.adyAxis2name, 
        },
      }); 
      this.adloading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      } 
      this.adEchartVisible = true
      this.adlineChartData.xAxisdata = data.x
      this.adlineChartData.actualData = data.y1
      this.adlineChartData.expectedData = data.y2
      this.adtableData = data.list
    },
    async GraphData() {
      this.toploading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADVERTISER_REPORT_ECHART}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          timeday:this.timeday,
          y1: this.yAxis1name,
          y2: this.yAxis2name,
          marketing_goal: this.marketing_goal,
          video_info_aweme_item_id:this.video_info_aweme_item_id,
          aweme_info_aweme_id:this.aweme_info_aweme_id,
          product_id:this.product_id
        },
      });
      this.toploading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      } 
      this.lineChartData.xAxisdata = data.x
      this.lineChartData.actualData = data.y1
      this.lineChartData.expectedData = data.y2
      this.advertisertableData = data.list
      // 如果图表已经初始化，更新图表选项
      if (this.myChart1) {
        this.myChart1.setOption(this.chartOptions.trend)
      }
      if (this.myChart2) {
        this.myChart2.setOption(this.chartOptions.distribution)
      }
      this.initCharts()  // 然后初始化图表
      window.addEventListener('resize', this.handleResize)
    },
    changeAxis2(val) {
      this.lineChartData.yAxis2 = this.yAxis2options[val].label
      this.yAxis2name = this.yAxis2options[val].name
      this.yAxis1options.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
      this.GraphData()
    },
    changeAxis1(val) {
      this.lineChartData.yAxis1 = this.yAxis1options[val].label
      this.yAxis1name = this.yAxis1options[val].name
      this.yAxis2options.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
      this.GraphData()
    },
    adchangeAxis2(val) {
      this.adlineChartData.yAxis2 = this.adyAxis2options[val].label
      this.adyAxis2name = this.adyAxis2options[val].name
      this.adyAxis1options.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
      this.echartOrder(this.ad)
    },
    adchangeAxis1(val) {
      this.adlineChartData.yAxis1 = this.adyAxis1options[val].label
      this.adyAxis1name = this.adyAxis1options[val].name
      this.adyAxis2options.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
      this.echartOrder(this.ad)
    },
    selectOk(){
      this.selectVisible = false
    },
    setTimeDay(timeday){
      this.timeday = timeday
      let todayDate = moment().format('YYYY-MM-DD')
      if(timeday == 0){
        this.range_date = [todayDate,todayDate]; 
      }else if(timeday == -1){
        this.range_date = [moment().subtract(1, 'days').format('YYYY-MM-DD'),moment().subtract(1, 'days').format('YYYY-MM-DD')];
      }else if(timeday == -3){
        this.range_date = [moment().subtract(3, 'days').format('YYYY-MM-DD'),todayDate];
      }else if(timeday == -7){
        this.range_date = [moment().subtract(7, 'days').format('YYYY-MM-DD'),todayDate];
      }else if(timeday == 1){
        this.range_date = [moment().startOf('month').format('YYYY-MM-DD'),todayDate];
      }else if(timeday == 2){ 
        this.range_date = [moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD').split('T')[0]];
      }
      if(this.topkey == 1){
        this.getReport()
      }else{
        this.GraphData()
        this.getCircleData()
      }
    },
    onTimeChange(e, date) { 
      this.range_date = date;
      this.timeday = ''
      if(this.topkey == 1){
        this.getReport();
      }else{
        this.GraphData();
        this.getCircleData()
      }
    },
    // 复制操作
    text_copy(context) {
      navigator.clipboard.writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch(err => {
          this.$message.error('复制失败');
        });
    },
    selectTips(){
      this.$message.error('请先勾选计划后操作');
    },
    onSearchKey(e) {
      console.log('输入的ID', e)
      this.order_id = e
      this.page = 1
      this.data = []
      this.getData()
    },
    onSearchRemark(){
      this.page = 1
      this.data = []
      this.getData()
    },
    onFinish() {
      if(!this.timer_status){
        return
      }
      this.$message.loading({ content: '刷新中...', key });
      this.deadtitle = '定时刷新中：正在刷新...';
      this.getTimeOut();
      setTimeout(() => {
        this.$message.success({ content: '刷新成功!', key, duration: 2 });
        this.deadtitle = '定时刷新中：倒计时'
        this.deadline = Date.now() + 1000 * 31
      }, 1000);
    },
    async getTimeOut() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SEND_SXT_REPORT_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id
        },
      });
      this.getReport();
      this.$refs.plan.getData()
      this.getData();
    },
    //start
    copyOrder(e) {
      this.ad = e;
      this.external_action = e.delivery_setting_external_action
      this.bid_mode = e.delivery_setting_bid_mode
      this.delivery_time = e.delivery_setting_delivery_time
      this.bid_type = e.delivery_setting_bid_type
      this.cpa_bid = e.delivery_setting_cpa_bid
      this.roi_goal = e.delivery_setting_roi_goal
      this.amount = e.delivery_setting_amount
      if(this.amount != '100' && this.amount != '200' && this.amount != '500' && this.amount != '1000' && this.amount != '2000'){
        this.diyamountcopy = this.amount
        this.amount = '-1'
      }
      console.log('出价',this.amount)
      this.copyVisible = true;
    },
    set_external_action(e) {
      this.external_action = e
      if (e != 'AD_CONVERT_TYPE_LIVE_ROI') {
        this.roi_goal = ''
        this.bid_type = 'AUTO_BID'
      } else {
        this.bid_type = 'MANUAL_BID'
      }
    },
    set_bid_mode(bid_mode_new){
      console.log(bid_mode_new)
      this.bid_mode = bid_mode_new; 
    },
    handleDeliveryTimeChange(e) {
      this.delivery_time = e.target.value;
    },
    handleBipTypeChange(e) {
      this.bid_type = e.target.value;
    },
    handleAmountChange(e) {
      this.amount = e.target.value;
    },
    //end
    govideo(e) {
      const strUrl = 'https://www.douyin.com/video/' + e.video_info_aweme_item_id;
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.target = '_blank';
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    async stopAll() {
      if (this.count < this.stopData.length && this.count) {
        return;
      }
      if (this.count == this.stopData.length) {
        this.closevisible = false;
        return;
      }
      this.okText = '执行中';
      const that = this;
      const suc = 0;
      for (let i = 0; i < this.stopData.length; i++) {
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.STOP_SXT_AD}`,
          method: 'POST',
          params: {
            advertiser_id: this.stopData[i].advertiser_id,
            order_id: this.stopData[i].order_id,
          },
        });
        if (code == 1) {
          this.stopData[i].stop_status = '关停成功';
        } else {
          this.stopData[i].stop_status = msg;
        }
        that.count = i + 1;
      }
      this.okText = '执行完毕';
      this.$message.success('执行完毕！');
      this.getData();
      this.selectedRowKeys = [];
      this.selectedRow = [];
      this.getStoptip()
    },
    async ztAll() {
      if (this.count < this.ztData.length && this.count) {
        return;
      }
      if (this.count == this.ztData.length) {
        this.ztvisible = false;
        return;
      }
      this.okText = '执行中';
      const that = this;
      const suc = 0;
      for (let i = 0; i < this.ztData.length; i++) {
        //执行接口 执行完获取详情
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.ZT_SXT_AD}`,
          method: 'POST',
          params: {
            advertiser_id: this.ztData[i].advertiser_id,
            order_id: this.ztData[i].order_id,
            renewal_budget:this.renewal_budget == -1 ? this.diyamount:this.renewal_budget,
            renewal_delivery_seconds:this.renewal_delivery_seconds
          },
        });
        if (code == 1) {
          this.ztData[i].stop_status = '追投成功';
        } else {
          this.ztData[i].stop_status = msg;
        }
        that.count = i + 1;
      }
      this.okText = '执行完毕';
      this.$message.success('执行完毕！');
      this.getData();
      this.selectedRowKeys = [];
      this.selectedRow = []; 
    },
    async getDetail(e,type='detail') { 
      if(type == 'detail'){ 
        this.orderDrawer = true;
      }else if(type == 'rate'){
        this.commissionVisible = true;
      }else if(type == 'product'){
        this.productDrawer = true
        this.productloading = true
      }
      console.log('参数', e);
      this.ad = e;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.STOP_SXT_AD_DETAIL}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          order_id: e.order_id,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.order_detail = data;
      if(type == 'rate'){
        this.commission_rate = data.commission_rate?data.commission_rate:100
        this.return_rate = data.return_rate?data.return_rate:10
        this.commissionVisible = true;
      }else if(type == 'product'){
        this.getProductDetail(e.product_info_id)
      }
    },
    async getProductDetail(product_id){
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_PRODUCT_DETAIL}`,
        method: 'POST',
        params: {
          product_id: product_id,
        },
      });
      this.productloading = false
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) {
        this.$message.error('未获取到商品详情');
        this.productDrawer = false
        return;
      }
      this.product_x = []
      this.product_y = []
      this.product_kol_num_y = []
      this.product_order_num_y = []
      this.product_view_num_y = []
      this.product_bfzhl_y = []
      this.product_rjzhl_y = []
      this.product_rjbfl_y = []

      this.productDetail = data
      if(data.daily_statistics.length>0) {
          let list = data.daily_statistics
          let that = this
          list.forEach(item => { 
            that.product_x.push(item.date)
            that.product_kol_num_y.push(item.kol_num)
            that.product_order_num_y.push(item.order_num)
            that.product_view_num_y.push(item.view_num)
            let bfzhl = 0
            if(item.order_num>0) {
              bfzhl = (item.view_num/item.order_num).toFixed(2)
            }
            that.product_bfzhl_y.push(Number(bfzhl))
            let rjzhl = 0
            if(item.kol_num>0) {
              rjzhl = (item.order_num/item.kol_num).toFixed(2)
            }
            that.product_rjzhl_y.push(Number(rjzhl))
            let rjbfl = 0
            if(item.kol_num>0) {
              rjbfl = (item.view_num/item.kol_num).toFixed(2)
            }
            that.product_rjbfl_y.push(Number(rjbfl))
          })
          that.checkNav(1)
        }
    },
    async setCommissionSubmit(){
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_PRODUCT_COMMISSION}`,
        method: 'POST',
        params: {
          advertiser_id: this.order_detail.advertiser_id,
          aweme_id: this.order_detail.aweme_info.aweme_id,
          aweme_item_id: this.order_detail.video_info.aweme_item_id,
          product_id: this.order_detail.product_info.id,
          commission_rate: this.commission_rate,
          return_rate:this.return_rate
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg)
      this.getData()
      this.commissionVisible = false
    },
    ztOrder(e){
      this.okText = '一键批量追投订单';
      this.count = 0;
      this.ztvisible = true; 
      this.ztData = [];
      e.stop_status = '待执行';
      this.ztData.push(e); 
    },
    stopOrder(e) {
      this.okText = '一键批量关停订单';
      console.log('参数', e);
      this.selectedRowKeys = [];
      this.selectedRow = [];
      this.stopData = [];
      e.stop_status = '待执行';
      this.stopData.push(e);
      this.closevisible = true;
      this.count = 0;
      this.getStoptip()
      // const that = this;
      // Modal.confirm({
      //   title: '关停提醒',
      //   content: '是否确定关停该计划？',
      //   onOk: () => {
      //     that.stopAction(e.advertiser_id, e.order_id);
      //   },
      // });
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRow = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(
        'selectedRowKeys changed: ',
        this.selectedRow,
        this.selectedRowKeys
      );
    },
    async stopAction(e) {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.STOP_SXT_AD}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          order_id: e.order_id,
        },
      });
      e.stop_status = msg; 
      // if (code == 0) {
      //   // this.$message.error(msg);
      //   return;
      // }
      // this.$message.success(msg);
    },
    createBtn() {
      // this.$router.replace('/sxt_batchCreatePlan');
      if( (this.product_id||this.video_info_aweme_item_id) && this.data.length > 0 ){
        this.select_video_info = [{
          aweme_item_id:this.data[0].video_info_aweme_item_id,
          aweme_name:this.data[0].aweme_info_aweme_name,
          aweme_id:this.data[0].aweme_info_aweme_id,
          video_cover_url:this.data[0].video_info_aweme_item_cover,
          title:this.data[0].video_info_aweme_item_title,
        }]
      }else{
        this.select_video_info = []
      }
      this.createDrawer = true
    }, 
    async getStoptip() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.AWEME_ORDER_QUATO_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id, 
        },
      }); 
      if (code == 0) {
        this.stoptip = '每日终止配额：- 笔 今日终止订单数：- 笔 今日剩余终止订单数量：- 笔'
        this.$message.error(msg);
        return;
      }
      this.stoptip = '每日终止配额：'+data.terminate_quota_info.terminate_quota_sum+' 笔 今日终止订单数：'+data.terminate_quota_info.terminate_quota_used+' 笔 今日剩余终止订单数量：'+(data.terminate_quota_info.terminate_quota_sum-data.terminate_quota_info.terminate_quota_used)+' 笔'
    },
    batchClose() {
      this.getStoptip()
      this.okText = '一键批量关停订单';
      this.count = 0;
      this.closevisible = true;
      if (this.selectedRowKeys.length == 0) {
        this.$message.info('请选择要关停的计划');
        return;
      }
      const selectRowArr = [];
      this.selectedRowKeys.forEach((item) => {
        if (this.dataMap[item]) {
          selectRowArr.push(this.dataMap[item]);
        }
      });
      selectRowArr.forEach(function (item) {
        item.stop_status = '待执行';
      });
      this.stopData = selectRowArr;
      console.log('selectRowArr1AAAAA', selectRowArr);
    },
    batchZt(){
      this.okText = '一键批量追投订单';
      this.count = 0;
      this.ztvisible = true;
      if (this.selectedRowKeys.length == 0) {
        this.$message.info('请选择要追投的计划');
        return;
      }
      const selectRowArr = [];
      this.selectedRowKeys.forEach((item) => {
        if (this.dataMap[item]) {
          selectRowArr.push(this.dataMap[item]);
        }
      });
      selectRowArr.forEach(function (item) {
        item.stop_status = '待执行';
      });
      this.ztData = selectRowArr;
      console.log('selectRowArr1Zt', selectRowArr);
    },
    copyOrderSubmit() {
      if (this.bid_type == 'MANUAL_BID' && this.cpa_bid == ''&& this.external_action != 'AD_CONVERT_TYPE_LIVE_ROI') {
        this.$message.error('请输入出价')
        return
      }
      if (this.external_action == 'AD_CONVERT_TYPE_LIVE_ROI' && this.roi_goal == '') {
        this.$message.error('请输入商品支付ROI')
        return
      }
      let amount = this.amount != '-1' ? this.amount : this.diyamountcopy
      console.log(amount)
      if (amount < 100 || amount % 10 != 0 || amount == '') {
        this.$message.error('投放金额需要大于100且为10的倍数')
        return
      }

      if (this.external_action == 'AD_CONVERT_TYPE_LIVE_ROI' && this.roi_goal == '') {
        this.$message.error('请输入支付目标roi')
        return
      }
      Modal.confirm({
        title: '提醒',
        zIndex: 10005,
        content: '确定是否复制' + this.copynum + '笔计划？',
        onOk: () => {
          this.copyOrderTask(this.ad);
        },
      });
    },
    batchCopy() { 
      Modal.confirm({
        title: '提醒', 
        content: '确定是否复制' + this.selectedRowKeys.length + '笔计划？',
        onOk: () => {
          this.copyOrderAction();
        },
      });
    },
    async copyOrderAction() {
      for (let i = 0; i < this.selectedRow.length; i++) {
        const e = this.selectedRow[i];
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.SXT_ADD_COPY_TASK_NEW}`,
          method: 'POST',
          params: {
            advertiser_id: e.advertiser_id,
            order_id: e.order_id,
            marketing_goal: this.marketing_goal,
            //20230909新增start
            aweme_id: e.aweme_info_aweme_id,
            aweme_item_id: e.video_info_aweme_item_id, 
            title : e.aweme_item_title, 
            video_cover_url : e.aweme_item_cover, 
            aweme_name : e.aweme_info_aweme_name, 
            //20230909新增end 
            times: 1, 
            dotype: 'NOW',
            source: 'WEB', 
          },
        });
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
        this.$message.success(msg);
      }
    },
    async copyOrderTask(e) {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_COPY_TASK_NEW}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          order_id: e.order_id,
          marketing_goal: this.marketing_goal,
          //20230909新增start
          aweme_id: e.aweme_info_aweme_id,
          aweme_item_id: e.video_info_aweme_item_id, 
          title : e.aweme_item_title, 
          video_cover_url : e.aweme_item_cover, 
          aweme_name : e.aweme_info_aweme_name, 
          //20230909新增end 
          times: this.copynum, 
          dotype: this.dotype,
          source: 'WEB',
          dotime: this.dotype == 'SET' ? this.dotime : '',
          is_batch: this.is_batch,
          interval_time: this.interval_time,
          tfnum: this.tfnum,
          tags:this.tags,
          is_white:this.is_white?1:0,
          //20240327复制
          external_action:this.external_action,
          bid_mode:this.bid_mode,
          delivery_time:this.delivery_time,
          bid_type:this.bid_type,
          cpa_bid:this.cpa_bid,
          roi_goal:this.roi_goal,
          amount:this.amount != '-1' ? this.amount : this.diyamountcopy,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.copyVisible = false;
    },
    handleTableChange(e, filters, sorter) {
      console.log('点击了', sorter);
      
      // 检查排序条件是否发生变化
      const sortChanged = sorter.order && 
        (this.sort !== sorter.order || this.sortby !== sorter.columnKey);
      
      // 设置排序参数
      if (sorter.order) {
        this.sort = sorter.order;
        this.sortby = sorter.columnKey;
      } else {
        this.sort = 'descend';
        this.sortby = 'ad_id';
      }
      
      // 只有在排序条件改变时才重置页码
      if (sortChanged) {
        this.page = 1;
        this.pagination = {
          ...e,
          current: 1
        };
      } else {
        // 正常分页逻辑
        this.page = e.current;
        this.pagination = e;
      }
      
      this.pagesize = e.pageSize;
      this.getData();
    },
    async handleChange(e) {
      console.log('获取到的状态', e);
      this.status = e;
      this.getData();
    },
    handletargetChange(e){
      this.delivery_setting_external_action = e
      this.getData();
    },
    showTodayData(){
      this.showToday = !this.showToday
      this.getData()
    },
    async getData() {
      console.log('aweme_info_aweme_id',this.aweme_info_aweme_id)
      this.spinning = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_SXT_AD_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          status: this.status,
          marketing_goal: this.marketing_goal,
          order_id: this.order_id,
          sortby: this.sortby,
          sort: this.sort,
          page: this.page,
          pagesize: this.pagesize,
          timeType: this.timeType,
          video_info_aweme_item_id:this.video_info_aweme_item_id,
          aweme_info_aweme_id:this.aweme_info_aweme_id,
          product_id:this.product_id,
          delivery_setting_external_action:this.delivery_setting_external_action,
          showToday:this.showToday?1:0,
          search_remark:this.search_remark
        },
      });
      this.spinning = false
      if (code == 0) {
        // this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.data = data.list;
      // this.lasttime = data.last_time_text || '--';

      this.pagination.total = data.count;
      this.tfz_tab = '投放中计划（'+data.tfz_count+'）'
      this.createDataMap(data.list);
    },

    getTasklist(data){
      this.wait_create = data.wait_create
    },

    createDataMap(list) {
      if (!list || list.length == 0) return;
      list.forEach((item) => {
        if (this.dataMap[item.ad_id]) return;
        this.dataMap[item.ad_id] = item;
      });
      console.log('this.dataMap', this.dataMap);
    },
    async getReport() { 
      this.toploading = true;
      this.y1 = []
      this.y2 = []
      this.y3 = []
      this.y4 = []
      this.y5 = []
      this.y6 = []
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_SXT_ADVERTISER_REPORT_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          timeday:this.timeday,
          video_info_aweme_item_id:this.video_info_aweme_item_id,
          aweme_info_aweme_id:this.aweme_info_aweme_id,
          product_id:this.product_id
        },
      });
      this.toploading = false
      if (code == 0) {
        // this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.report = data; 
      if(data.ad_columns){
        this.columns = JSON.parse(data.ad_columns)
      }else{
        this.columns = this.$options.data().columns
      }
      // this.columns = this.$options.data().columns
      if(!this.video_info_aweme_item_id&&!this.product_id&&!this.aweme_info_aweme_id){
        this.xData = data.xData;
        this.y1 = data.y1;
        this.y2 = data.y2;
        this.y3 = data.y3;
        this.y4 = data.y4;
        this.y5 = data.y5;
        this.y6 = data.y6;  
      }
    },
    downExcel(){ 
      const strUrl  = "https://qc.zpfly.com/api/sxt/exportExcel?marketing_goal="+this.marketing_goal+"&advertiser_id="+this.advertiser_id+'&timeType='+this.timeType+'&video_info_aweme_item_id='+this.video_info_aweme_item_id+'&aweme_info_aweme_id='+this.aweme_info_aweme_id+'&token='+localStorage.getItem('token')
                      +'&delivery_setting_external_action='+this.delivery_setting_external_action
                      +'&downmonth='+this.downmonth
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.target = "_blank";
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    changeTab(e) {
      console.log('切換tab', e);
      if (e == 1) {
        this.timeType = 'ALL'
      } else if (e == 2) {
        this.timeType = 'TODAY'
      } else if (e == 3) {
        this.timeType = 'YESTODAY'
      } else if (e == 4) {
        this.timeType = 'DELIVERY_OK'
      }else if (e == 5) {
        this.timeType = 'WEEKDAY'
      }else if (e == 6) {
        this.timeType = 'MONTH'
      }else if (e == 7) {
        this.timeType = 'YESMONTH'
      }else if (e == 8) {
        this.timeType = 'THREEDAY'
      }else if (e == 30) {
        this.timeType = 'THIRTYDAY'
      }else if (e == "-1") {
        this.timeType = 'WAIT'
      }else if (e == "-99") {
        this.timeType = 'NO_DELIVERY_OK'
      }
      console.log("tttt",this.timeType)
      if(e != -1){
        this.page = 1
        this.data = []
        this.getData()
      }
    },
    initCharts() {
      if (this.$refs.chart1) {
        this.myChart1 = echarts.init(this.$refs.chart1)
        this.myChart1.setOption(this.chartOptions.trend)
      }
      if (this.$refs.chart2) {
        this.myChart2 = echarts.init(this.$refs.chart2)
        this.myChart2.setOption(this.chartOptions.distribution)
      }
      // this.$nextTick(() => {  // 确保DOM已更新
        
      // })
    },
    handleResize() {
      if (this.myChart1) this.myChart1.resize()
      if (this.myChart2) this.myChart2.resize()
    },
    changeCircle(e){
      this.circleIndex = e
      this.getCircleData()
    },
    getCircleData() {
      if(this.circleIndex == 'VIDEO' || this.circleIndex == 'AWEME'){
        this.getVideoData(this.circleIndex)
      }else if(this.circleIndex == 'PRODUCT'){
        this.getProductData()
      }else{
        this.getOtherData(this.circleIndex)
      }
    },
    async getOtherData(type) {
      console.log(3333)
      this.toploading = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_VIDEO_LIVE_REPORT_OTHER}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal:'VIDEO_PROM_GOODS',
          video_info_aweme_item_id:this.video_info_aweme_item_id,
          aweme_info_aweme_id:this.aweme_info_aweme_id,
          product_id:this.product_id,
          type:type,
          page:1,
          pagesize:100, 
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          sortby:'stat_cost',
        },
      });
      this.toploading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      // 格式化数据为饼图所需格式
      const circleData = data.list.map(item => {
        const value = parseFloat(item[this.distributionMetric]);
        return {
          name: item.name,
          value: this.formatValue(value)
        };
      }); 
      this.circleData = circleData;
      this.updateCharts();
    },
    async getProductData(){
      this.toploading = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_PRODUCT_LIST_NEW}`,
        method: 'POST',
        params: { 
          advertiser_id: this.advertiser_id,
          marketing_goal:'VIDEO_PROM_GOODS',
          videotype :'ALL',
          searchKey:this.product_id,
          video_info_aweme_item_id:this.video_info_aweme_item_id,
          aweme_info_aweme_id:this.aweme_info_aweme_id,
          product_id:this.product_id,
          page:1,
          pagesize:100, 
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          sortby:'stat_cost',
        },
      });
      this.toploading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      // 格式化数据为饼图所需格式
      const circleData = data.list.map(item => {
        const value = parseFloat(item[this.distributionMetric]);
        return {
          name: item.product_info_name || '未知商品',
          value: this.formatValue(value)
        };
      }); 
      this.circleData = circleData;
      this.updateCharts();
    },
    async getVideoData(videotype) {
      console.log(3333)
      this.toploading = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_VIDEO_LIVE_REPORT}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal:'VIDEO_PROM_GOODS',
          videotype :'ALL',
          searchKey:videotype=='VIDEO'?this.video_info_aweme_item_id:this.aweme_info_aweme_id,
          video_info_aweme_item_id:this.video_info_aweme_item_id,
          aweme_info_aweme_id:this.aweme_info_aweme_id,
          product_id:this.product_id,
          page:1,
          pagesize:100, 
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          sortby:'stat_cost',
          group:videotype=='VIDEO'?'video_info_aweme_item_id':'aweme_info_aweme_id'
        },
      });
      this.toploading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      // 格式化数据为饼图所需格式
      const circleData = data.list.map(item => {
        const value = parseFloat(item[this.distributionMetric]);
        return {
          name: videotype == 'VIDEO'?item.video_info_aweme_item_title:item.aweme_info_aweme_name,
          value: this.formatValue(value)
        };
      }); 
      this.circleData = circleData;
      this.updateCharts();
    },
    // 格式化数值
    formatValue(value) {
      if (this.distributionMetric === 'pay_order_count') {
        return parseInt(value);
      }
      // 对于金额，保留两位小数并转换为数字类型
      return parseFloat(parseFloat(value).toFixed(2));
    },
    // 获取指标名称
    getDistributionMetricName(metric) {
      const metricNames = {
        'stat_cost': '消耗',
        'pay_order_amount': '成交订单金额',
        'pay_order_count': '成交订单数'
      };
      return metricNames[metric] || metric;
    },
    updateCharts() {
      this.$nextTick(() => {  // 确保数据更新后再更新图表
        if (this.myChart1) {
          this.myChart1.setOption(this.chartOptions.trend)
        }
        if (this.myChart2) {
          this.myChart2.setOption(this.chartOptions.distribution)
        }
      })
    },
    changeTopTab(e){
      this.topkey = e
      if(e == 1){
        this.getReport()
      }else{
        this.lineChartData.yAxis1 = this.yAxis1options[0].label
        this.yAxis1name = this.yAxis1options[0].name
        this.lineChartData.yAxis2 = this.yAxis2options[4].label
        this.yAxis2name = this.yAxis2options[4].name

        this.getCircleData()  // 先获取数据
        this.$nextTick(async () => {  // 等待DOM更新
          await this.GraphData()  // 先获取数据
          this.initCharts()  // 然后初始化图表
          window.addEventListener('resize', this.handleResize)
        });
      }
      console.log('切換tab', e);
    },
  },
};
</script>

<style lang="less" scoped>
.extra-wrapper {
  position: absolute;
  right: 0px;
}
.ant-card-head-wrapper{
  text-align: left !important;
  font-weight: bold !important;
  color: #000;
}
.widget-1 {
  display: flex;
  .ant-statistic-content{
    font-family: open sans,Helvetica,Arial,sans-serif;
    font-weight: 700;
    color: inherit;
    font-size: 26px;
    line-height: 30px; 
    text-align: center;
    margin: 10px auto;
  }
  .icon {
    width: 48px;
    height: 48px;
    position: absolute; 
    right: 16px;
    margin: auto;
    background-color: #1890ff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,.12);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.ant-tabs-tab {
  font-weight: bold !important;
}

.extra-item {
  display: inline-block;
  margin-right: 24px;

  a {
    margin-left: 24px;
    color: #666;
    font-weight: bold;
  }

  .selected {
    color: #1890ff;
  }
}

.searchResult {
  .name {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
}

.aweme {
  display: flex;
}
.aweme-left{
  width: 60px;
}
.aweme-right {
  text-align: left;
  padding-left: 10px;
  width: 220px;
  .aweme-title {
    color: #000;
    font-weight: bold;
    margin-bottom: 10px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 210px;
  }
}

.tips {
  margin-bottom: 10px;
}

.showTemplate {
  .dataOverview {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0;
  }

  .dataViewItem {
    flex: 1;
    margin-right: 0.5%;
    margin-left: 0.5%;
    border-radius: 15px;
    float: left;
    box-shadow: 0 2px 8px #00000026;
    margin-bottom: 10px;
    overflow: hidden;
    height: 120px;

    div {
      text-align: left;
      color: #333;
      font-size: 18px;
      padding-top: 20px;
      padding-left: 20px;
    }

    p {
      font-size: 24px;
      padding-top: 5px;
      font-weight: bold;
    }
  }
}

.copy-icon {
  height: 65px;
  width: 55px;
  border-radius: 5px;
  cursor: pointer;
}

.rowOperate {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 30px;
  .actionItem {
    margin-left: 10px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.filterCondition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  span {
    margin-left: 20px;
  }

  // .createBtn {
  //   margin-left: 20px;
  // }
}

.tags-container {
  padding: 16px 0px;
  overflow: hidden;
}

.tags-container .ad-tag {
  float: left;
  margin-left: 16px;
}

.tags-container .ad-tag:first-child {
  margin-left: 0;
}

.tags-container .inbl {
  display: inline-block;
  vertical-align: middle;
}
.level-2 {
  margin-top: 15px;
  margin-bottom: 12px;
  line-height: 20px;
  font-weight: 600;
  font-size: 14px;
  color: #323335;
}
.cpa_bid {
  width: 150px;
  margin-left: 20px;
}
.tags-container .roi-input {
  position: relative;
  top: 1px;
}

.tags-container .roi-target-box {
  display: inline-block;
  margin-left: 24px;
}

.tags-container .info-item {
  float: left;
  height: 26px;
  display: flex;
  //  margin-left:24px;
  position: relative;
}

.avatar {
  widows: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 5px;
}

.tags-container .info-item.editable {
  padding-right: 28px;
}

.tags-container .info-item .content {
  display: inline-block;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-container .info-item .content .nobid-bid-content {
  color: #999;
}

.tag {
  background: #f2f2f2;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 8px;
  margin-right:10px;
  &:last-child{
    margin-right:0px;
  }
}

.tag.red {
  background: #fff1ef;
  color: #e5453f;
}

.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.tag.green {
  background: #e6f8ee;
  color: #34ba7b;
}

.copynum {
  font-weight: bold;
  color: red;
}

.product-item {
  display: flex;
  height: 56px;
  margin-top: 8px;
}

.product-item .good {
  padding-left: 0;
}

.product-item .icon {
  border-radius: 4px;
  height: 56px;
  width: 56px;
}

.product-item .info {
  // padding-top: 3px;
}
.product-item .info .name {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 0 0 8px 16px;
}
//start
.external-action-wrapper .layer {
  margin-bottom: 8px;
}

.external-action-wrapper .layer .row {
  display: flex;
  flex-wrap: wrap;
}

.external-action-wrapper .layer .row .radio {
  margin-bottom: 8px;
  margin-right: 16px;
}


.external-action-radio-button.checked {
  color: #1890ff;
  background-color: #fff;
  border: 1px solid #1890ff;
}

.newico {
  background-color: red;
  color: #fff;
  font-size: 10px;
  display: block;
  border-radius: 3px;
  position: absolute;
  right: 1px;
  top: 1px;
  padding: 0px 5px;
  font-weight: bold;
  height: 16px;
  line-height: 16px;
}

.external-action-radio-button {
  color: #323335;
  background: #f8f8f9;
  background-color: rgb(248, 248, 249);
  border-radius: 4px;
  width: 160px;
  height: 48px;
  display: flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0);
}

.external-action-radio-button .label {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
}

.external-action-radio-button .icon {
  margin-left: 10px;
  margin-right: 4px;
}
.title-box {
  display: flex;
  align-items: center;
}
//end
.aweme-id{
  background: #e6f7ff;
  padding-left: 5px;
  padding-top: 2px;
  border-radius: 3px;
  padding-right: 5px;
  margin-top: 5px;
  cursor: pointer;
  display: inline-flex;
  &:hover{
    background: #fff;
  }
  .aweme-id-left{
    display: flex;
    img{
      width: 30px;
      height: 30px;
      border-radius: 3px;
      margin-top: 2px
    }
  }
  .aweme-id-right{
    h6{
      font-size: 12px;
      margin: 0px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 180px;
      padding-left: 5px;
    }
    p{
      font-size: 12px;
      margin: 0px;
      padding-left: 5px;
    }
  }
}
.product-item .info .name {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 0 0 8px 16px;
}

.product-item .info .id,
.product-item .info .price {
  color: #999;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 16px;
}

.product-item .info .separator {
  border-right: 1px solid #999;
  display: inline-block;
  height: 8px;
  position: relative;
}

.product-item .info .price-num {
  color: #333;
  margin-left: 8px;
}

.ad-drawer__aweme-info {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 16px;
}

.title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 34px;
  margin-top: 20px;
}

.board-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
  min-width: 932px;

  .overview-board {
    background: #f2f2f2;
    background-color: #f2f2f2;
    margin: 0 10px 10px 0;
    border-radius: 8px;
    cursor: pointer;
    height: 108px;
    width: 175px;
    position:relative;
    span{
      position:absolute;
      right: 5px;
      top: 2px;
      font-size:12px;
      color:red
    }
    .inner {
      border-radius: 4px;
      padding: 12px 12px 17px;

      .metric {
        color: #252729;
        font-size: 14px;
        font-weight: 600;
        height: 20px;
        line-height: 20px;
        margin: 0;
      }

      .value {
        font-size: 20px;
        margin-top: 8px;
        font-weight: bold;
        color: rgb(51, 51, 51);
      }
    }
  }
  .active{
    background:#e6f7ff
  }
}

.setting-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  min-height: 44px;
  padding: 12px 16px;
  width: 50%;
  float: left;

  label {
    color: #333;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 24px;
    width: 80px;
  }

  .display-value {
    color: #333;
    flex: 1 1;
  }
}

.footer {
  position: fixed;
  bottom: 0px;
  background: #fff;
  height: 80px;
  width: 940px;
  line-height: 80px;
  border-top: 1px solid #eee;

  button {
    margin-right: 10px;
  }
}

.videoimg {
  width: 55px;
  height: 80px;
  border-radius: 3px;
  cursor: pointer;
  margin-top: 5px;
}
.dialog-left{
    width: 180px;
    float: left; 
    padding-top: 20px; 
    height: 100%;
    border-right: 1px solid #e5e5e5;
}
.dialog-left ul li{
    margin: 0 auto;
    line-height: 40px;
    font-size: 16px;
    color: #2d3035; 
    width: 130px;
    height: 40px;
    border-radius: 3px;
    margin-bottom: 10px;
    text-align: left;
    cursor: pointer;
}  
.dialog-center{ 
    width: 630px;
    float: left; 
    padding:10px 20px; 
    color: #242a37; 
    ul{
      padding: 0;
      margin: 0;
    }
}
.dialog-right{
    width: 190px;
    float: left;  
    padding: 10px; 
    color: #939cc0; 
    height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-track-color: transparent;
    -ms-scrollbar-track-color: transparent;
    scrollbar-width: thin;
    border-left: 1px solid #e5e5e5;
}
.dialog-center-title{
    font-size: 16px;
    margin-bottom: 10px;
}
li{
  list-style: none;
}
.dialog-right ul li{ 
    margin: 0 auto;
    line-height: 30px;
    font-size: 14px;
    color: #13151a; 
    width: 184;
    height: 30px;
    border-radius: 3px;
    margin-bottom: 10px;
    text-align: left;
    padding-left: 10px;
    cursor: pointer;
    background: #f2f2f2;
    position: relative;
}
.dialog-right ul li span{
    float: right; 
    margin-right: 10px; 
}
.dialog-center ul li{
    width: 25%;
    margin-bottom: 10px;
    float: left;
}
.dialog-right ul{
  margin: 0;
  padding: 0;
}
.yAxis {
      display: flex;
      align-items: center;
      justify-content: center;

      input {
        width: 145px;
        // background: #F2F2F2;
        border-radius: 5px;
        // border: none;
      }

      &>div {
        display: flex;
        align-items: center;
      }

      section {
        width: 13px;
        height: 12px;
        background: #ff4d4f;
        border-radius: 3px;
        margin-right: 10px;
      }

      &>div:nth-child(1) {
        margin-right: 35px;

        section {
          background-color: #1890ff;
        }
      }
    }

    .yAxis+.totops {
      height: 0;
      opacity: 0;
    }

// .scroll-tabox{
//   height: 100vh;
// 	position: relative;
//   overflow: visible;
// 	/deep/ .ant-table-thead{
// 		position:sticky;
// 		top : 130px; 
// 		z-index:9999;
//     background: #fff;
// 	}
// }

// ::v-deep .ant-table-scroll {
//   height: calc(100vh - 210px);
//   overflow: auto scroll;
//  }
// ::v-deep .ant-checkbox + span{
//   padding:0px !important
// }
    .ant-card{
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border-top: 1px solid #efefef;
}
.acss-14lc1cu {
    position: relative;
    width: 100%;
    overflow: hidden;
}
.acss-1fpsglh {
    margin-top: 8px;
    padding-top: 9px;
    border-top: 1px solid rgba(5, 5, 5, 0.06);
}
.acss-grxbm {
    position: relative;
    width: 100%;
    margin-bottom: 12px;
}
.acss-eji7bv {
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
}
.acss-1x0bxe0 {
    font-size: 14px;
    line-height: 22px;
}
.acss-72p16p {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.88);
}
.acss-qdes8r {
    position: relative;
    top: 4px;
    float: left;
    margin-right: 20px;
}
.acss-1odwksc {
    float: left;
}
.acss-1qoci3j {
    height: 22px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 22px;
}
.acss-18kfphl {
    position: absolute;
    top: 4px;
    right: 0;
    line-height: 1;
    cursor: pointer;
}
.acss-f1zikh {
    height: 38px;
    margin-top: 4px;
    margin-bottom: 0;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.88);
    font-size: 30px;
    line-height: 38px;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
}
.acss-16mkun2{
  margin-top: 10px;
}
.remark{
  color: red;overflow: hidden;white-space: normal;text-overflow: ellipsis;width: 200px;display: block;cursor: pointer;
}
/deep/ .ant-checkbox + span{
  padding-left: 2px;
}
/deep/ .ant-form-item{
  margin-bottom: 15px !important;
}
// .scroll-tabox {
//   position: relative;
//   padding-bottom: 50px;
//   min-height: calc(100vh - 250px);
// }

// ::v-deep .ant-table {
//   min-height: calc(100vh - 300px);
// }

::v-deep .ant-table-body {
  // min-height: calc(100vh - 380px);

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 4px;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #bfbfbf;
    }
  }

  &::-webkit-scrollbar-track {
    background-color: #f5f5f5;
    border-radius: 4px;
  }
}

/* Firefox scrollbar styles */
::v-deep .ant-table-body {
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

// ... existing code ...
</style>
